import React, { useEffect, useState, useRef, Component } from 'react';
import { ArrowLeftIcon, FileTextIcon, UserIcon, BuildingIcon, CalendarIcon, ClockIcon, DollarSignIcon, CheckCircleIcon, XCircleIcon, SendIcon, DownloadIcon, PrinterIcon, PencilIcon, TrashIcon, RefreshCwIcon, ExternalLinkIcon, TagIcon, MailIcon, PhoneIcon, MapPinIcon, InfoIcon, CheckIcon, AlertCircleIcon, PackageIcon, TruckIcon, BarChart2Icon, StarIcon, ClipboardIcon, MoreHorizontalIcon, BookmarkIcon, ShareIcon, EyeIcon, ChevronRightIcon, MessageSquareIcon, LinkIcon, MoreVerticalIcon, ChevronDownIcon, ArrowUpRightIcon, ArchiveIcon, CopyIcon, HeartIcon, FolderIcon, FileIcon, PieChartIcon, BellIcon, BadgeCheckIcon, ShoppingCartIcon, HistoryIcon, StickyNoteIcon, ThumbsUpIcon, ThumbsDownIcon, HelpCircleIcon, CreditCardIcon, GlobeIcon, ZapIcon, Activity, Edit2Icon, PlusIcon, MoveRightIcon, ChevronLeftIcon, UsersIcon, PercentIcon, ShieldIcon, LockIcon, Layers, BarChart, PenToolIcon, XIcon, FilterIcon, TrendingUpIcon, TrendingDownIcon, DollarSign, Target, Zap, CheckSquare, Clock, Clipboard, Hash, Paperclip, Briefcase, Users, LayoutDashboard, CrownIcon, LayoutIcon } from 'lucide-react';
export function ViewQuotePage({
  quoteData,
  onBack,
  onEdit
}) {
  const [activeSection, setActiveSection] = useState('overview');
  const [isFavorite, setIsFavorite] = useState(false);
  const [currentItemDetails, setCurrentItemDetails] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showNotes, setShowNotes] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showItemDrawer, setShowItemDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [newNote, setNewNote] = useState('');
  const [privateNote, setPrivateNote] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState('standard');
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);
  const actionMenuRef = useRef(null);
  const shareMenuRef = useRef(null);
  const printableQuoteRef = useRef(null);
  const templateSelectorRef = useRef(null);
  // Close menus when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setShowActionMenu(false);
      }
      if (shareMenuRef.current && !shareMenuRef.current.contains(event.target)) {
        setShowShareMenu(false);
      }
      if (templateSelectorRef.current && !templateSelectorRef.current.contains(event.target)) {
        setShowTemplateSelector(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Toggle favorite status
  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };
  // Handle showing item details
  const handleViewItem = item => {
    setSelectedItem(item);
    setShowItemDrawer(true);
  };
  // Handle adding a new note
  const handleAddNote = () => {
    if (newNote.trim() === '') return;
    // Here you would typically add the note to your state or send to backend
    console.log('Adding note:', newNote, 'Private:', privateNote);
    // Reset form
    setNewNote('');
    setPrivateNote(false);
  };
  // Handle printing the quote
  const handlePrintQuote = () => {
    const printContent = printableQuoteRef.current;
    if (!printContent) return;
    const originalContents = document.body.innerHTML;
    const printContents = printContent.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    // Re-attach event listeners
    window.location.reload();
  };
  // Toggle template selector
  const toggleTemplateSelector = () => {
    setShowTemplateSelector(!showTemplateSelector);
  };
  // Select template
  const handleSelectTemplate = template => {
    setSelectedTemplate(template);
    setShowTemplateSelector(false);
  };
  // Ejemplo de datos para la demostración
  const quote = {
    id: quoteData?.id || 'QT-5875',
    status: 'pending',
    title: '8" Valley Pivot System with Corner Arm',
    description: 'Complete irrigation system with corner arm extension for rectangular fields',
    customer: 'Unknown Customer',
    customerEmail: 'contact@example.com',
    customerPhone: '+1 (555) 123-4567',
    company: 'Direct Customer',
    companyAddress: '123 Irrigation Blvd, Farmington, CA 95689, United States',
    date: 'Unknown date',
    expiresIn: '2023-12-31',
    amount: 27820.0,
    currency: '$',
    discount: 10,
    tax: 7,
    taxAmount: 1947.4,
    total: 29767.4,
    quotedBy: 'Unknown',
    salesManager: 'Unknown',
    region: 'North America',
    country: 'USA',
    paymentTerms: 'Net 30',
    deliveryTerms: 'FOB Shipping Point',
    validityPeriod: '30 days',
    tags: ['Pivot', 'Corner'],
    items: [{
      id: 1,
      name: '8" Valley Pivot',
      description: 'Standard 8-inch Valley Pivot system with GPS',
      quantity: 1,
      unitPrice: 18500.0,
      discount: 0,
      total: 18500.0
    }, {
      id: 2,
      name: 'Corner Arm Extension',
      description: 'Corner arm extension for increased coverage',
      quantity: 1,
      unitPrice: 5200.0,
      discount: 0,
      total: 5200.0
    }, {
      id: 3,
      name: 'Smart Control Panel',
      description: 'Advanced control panel with remote access',
      quantity: 1,
      unitPrice: 1800.0,
      discount: 10,
      total: 1620.0
    }, {
      id: 4,
      name: 'Installation Service',
      description: 'Professional installation and setup',
      quantity: 1,
      unitPrice: 2500.0,
      discount: 0,
      total: 2500.0
    }],
    notes: [{
      id: 1,
      text: 'Customer requires installation before the growing season starts in April. System should be configured for corn and soybean rotation.',
      author: 'John Smith',
      date: '2 days ago',
      isPrivate: false
    }, {
      id: 2,
      text: 'Follow up with customer about payment schedule options.',
      author: 'Sarah Johnson',
      date: '1 day ago',
      isPrivate: true
    }],
    terms: 'This quote is valid for 30 days from the date of issue. Installation schedule to be determined upon acceptance.',
    attachments: [{
      name: 'System_Specifications.pdf',
      size: '2.4 MB',
      type: 'pdf'
    }, {
      name: 'Field_Layout.pdf',
      size: '1.8 MB',
      type: 'pdf'
    }, {
      name: 'Terms_and_Conditions.pdf',
      size: '0.5 MB',
      type: 'pdf'
    }, {
      name: 'Installation_Guide.pdf',
      size: '3.2 MB',
      type: 'pdf'
    }],
    history: [{
      date: '3 days ago',
      action: 'Quote created',
      user: 'Daniel Alejandro',
      details: 'Initial quote created with 4 items'
    }, {
      date: '2 days ago',
      action: 'Quote sent to customer',
      user: 'Daniel Alejandro',
      details: 'Quote #QT-5875 sent via email to contact@example.com'
    }, {
      date: '1 day ago',
      action: 'Customer viewed quote',
      user: 'System',
      details: 'Quote was viewed by customer via the shared link'
    }, {
      date: '5 hours ago',
      action: 'Quote updated',
      user: 'Daniel Alejandro',
      details: 'Added 10% discount to Smart Control Panel'
    }],
    score: 92,
    approvalStatus: {
      level1: {
        name: 'Sales Manager',
        status: 'approved',
        date: '3 days ago',
        by: 'John Smith'
      },
      level2: {
        name: 'Finance Department',
        status: 'pending',
        date: null,
        by: null
      },
      level3: {
        name: 'Executive Approval',
        status: 'not_required',
        date: null,
        by: null
      }
    },
    competitors: [{
      name: 'IrriTech Solutions',
      price: 32150.0,
      strengths: 'Longer warranty, 24/7 support',
      weaknesses: 'More expensive, longer delivery time'
    }, {
      name: 'FarmSystems Inc.',
      price: 26500.0,
      strengths: 'Lower price point, faster installation',
      weaknesses: 'Less durable components, limited support'
    }]
  };
  // Format currency
  const formatCurrency = amount => {
    return `$${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  // Get status config
  const getStatusConfig = status => {
    switch (status) {
      case 'pending':
        return {
          icon: <Clock size={14} className="text-amber-500" data-id="element-5382" data-mp="2na7enh26d9k0" />,
          label: 'Pending Approval',
          color: 'bg-amber-100 text-amber-700 border-amber-200'
        };
      case 'approved':
        return {
          icon: <CheckSquare size={14} className="text-green-500" data-id="element-5383" data-mp="1bvtykydnxyej" />,
          label: 'Approved',
          color: 'bg-green-100 text-green-700 border-green-200'
        };
      case 'expired':
        return {
          icon: <XCircleIcon size={14} className="text-red-500" data-id="element-5384" data-mp="wtbyvhuxody7" />,
          label: 'Expired',
          color: 'bg-red-100 text-red-700 border-red-200'
        };
      case 'draft':
        return {
          icon: <Edit2Icon size={14} className="text-blue-500" data-id="element-5385" data-mp="16pfb5gji1syv" />,
          label: 'Draft',
          color: 'bg-blue-100 text-blue-700 border-blue-200'
        };
      default:
        return {
          icon: <InfoIcon size={14} className="text-gray-500" data-id="element-5386" data-mp="1fhqoc0plrjww" />,
          label: 'Unknown',
          color: 'bg-gray-100 text-gray-700 border-gray-200'
        };
    }
  };
  // Get file icon based on type
  const getFileIcon = fileType => {
    switch (fileType) {
      case 'pdf':
        return <FileTextIcon size={16} className="text-red-500" data-id="element-5387" data-mp="1ugkpfr9skd72" />;
      case 'doc':
      case 'docx':
        return <FileTextIcon size={16} className="text-blue-500" data-id="element-5388" data-mp="3r931smnzpi5t" />;
      case 'xls':
      case 'xlsx':
        return <FileTextIcon size={16} className="text-green-500" data-id="element-5389" data-mp="18g6nqajk6w" />;
      case 'jpg':
      case 'png':
        return <FileIcon size={16} className="text-purple-500" data-id="element-5390" data-mp="298d0p22e7xhk" />;
      default:
        return <FileIcon size={16} className="text-gray-500" data-id="element-5391" data-mp="2e5wg45atugb3" />;
    }
  };
  // Calculate days remaining until expiry
  const getDaysRemaining = () => {
    if (!quote.expiresIn) return 0;
    const today = new Date();
    const expiryDate = new Date(quote.expiresIn);
    const timeDiff = expiryDate.getTime() - today.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  };
  const daysRemaining = getDaysRemaining();
  // Get expiry status and color
  const getExpiryStatus = () => {
    if (daysRemaining <= 0) {
      return {
        label: 'Expired',
        color: 'text-red-500',
        icon: <XCircleIcon size={14} className="text-red-500" data-id="element-5392" data-mp="35y3ut06rvimu" />
      };
    } else if (daysRemaining <= 7) {
      return {
        label: `Expires in ${daysRemaining} days`,
        color: 'text-amber-500',
        icon: <AlertCircleIcon size={14} className="text-amber-500" data-id="element-5393" data-mp="3fuyw1qufjx4t" />
      };
    } else {
      return {
        label: `Expires in ${daysRemaining} days`,
        color: 'text-green-500',
        icon: <CheckCircleIcon size={14} className="text-green-500" data-id="element-5394" data-mp="3l02jljy9reyn" />
      };
    }
  };
  const expiryStatus = getExpiryStatus();
  // Calculate score color
  const getScoreColor = score => {
    if (score >= 80) return 'text-green-500';
    if (score >= 60) return 'text-blue-500';
    if (score >= 40) return 'text-amber-500';
    return 'text-red-500';
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-5395" data-mp="cmwt7fyisd1p">
      {/* Left sidebar - Navigation */}
      {showSidebar && <div className="w-64 bg-white border-r border-gray-200 flex flex-col h-full" data-id="element-5396" data-mp="7o1xjdfgeu06">
          <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-5397" data-mp="2swcshxsfldo">
            <button onClick={onBack} className="text-gray-500 hover:text-gray-700 flex items-center text-sm font-medium" data-id="element-5398" data-mp="3uyjhl0vmktu7">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-5399" data-mp="vd4lf30olj34" />
              Back to Quotes
            </button>
            <button onClick={() => setShowSidebar(false)} className="text-gray-400 hover:text-gray-600" data-id="element-5400" data-mp="2ksfb17mxudwg">
              <ChevronLeftIcon size={18} data-id="element-5401" data-mp="2pr8tleh30v3h" />
            </button>
          </div>
          <div className="p-4" data-id="element-5402" data-mp="2ptcuronljg02">
            <div className="flex items-center justify-between mb-4" data-id="element-5403" data-mp="2b35m20ne5bck">
              <div className="flex items-center" data-id="element-5404" data-mp="2b0rpfnd2br2w">
                <div className="bg-blue-100 p-2 rounded-md" data-id="element-5405" data-mp="2g0nn74v62ma0">
                  <FileTextIcon size={16} className="text-blue-600" data-id="element-5406" data-mp="2227fpbphcrqt" />
                </div>
                <div className="ml-3" data-id="element-5407" data-mp="2710vjas8ouu5">
                  <h2 className="text-sm font-medium text-gray-900" data-id="element-5408" data-mp="27223v7hvf386">
                    Quote #{quote.id}
                  </h2>
                  <p className="text-xs text-gray-500" data-id="element-5409" data-mp="1s5kuglt8ryo9">Standard Quote</p>
                </div>
              </div>
              <button onClick={toggleFavorite} className={`${isFavorite ? 'text-amber-500' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-5410" data-mp="1x4o1ucwp2gze">
                <BookmarkIcon size={16} className={isFavorite ? 'fill-amber-500' : ''} data-id="element-5411" data-mp="3rhdu6q7ezi4o" />
              </button>
            </div>
            <div className="space-y-1 mb-6" data-id="element-5412" data-mp="1fuaf1oe5v5hm">
              <NavItem active={activeSection === 'overview'} icon={<LayoutDashboard size={16} data-id="element-5414" data-mp="1avqofaomh5ix" />} label="Overview" onClick={() => setActiveSection('overview')} data-id="element-5413" data-mp="1aufmzhing9uz" />
              <NavItem active={activeSection === 'items'} icon={<ShoppingCartIcon size={16} data-id="element-5416" data-mp="1ksvdbi9urf3f" />} label="Quote Items" onClick={() => setActiveSection('items')} badge={quote.items.length} data-id="element-5415" data-mp="1pkwlarzzmjnn" />
              <NavItem active={activeSection === 'customer'} icon={<UserIcon size={16} data-id="element-5418" data-mp="1uiexcr9axezv" />} label="Customer Info" onClick={() => setActiveSection('customer')} data-id="element-5417" data-mp="1yip2k1p9s1do" />
              <NavItem active={activeSection === 'terms'} icon={<ClipboardIcon size={16} data-id="element-5420" data-mp="28ho2mvvyyop2" />} label="Terms & Conditions" onClick={() => setActiveSection('terms')} data-id="element-5419" data-mp="28hxuyq4hl7xx" />
              <NavItem active={activeSection === 'attachments'} icon={<Paperclip size={16} data-id="element-5422" data-mp="e3dekpn77ykc" />} label="Attachments" onClick={() => setActiveSection('attachments')} badge={quote.attachments.length} data-id="element-5421" data-mp="23jwemcyg3mq5" />
              <NavItem active={activeSection === 'approvals'} icon={<CheckSquare size={16} data-id="element-5424" data-mp="an0qwvzj4c3g" />} label="Approval Workflow" onClick={() => setActiveSection('approvals')} data-id="element-5423" data-mp="96wohpwfva4m" />
              <NavItem active={activeSection === 'analytics'} icon={<BarChart size={16} data-id="element-5426" data-mp="kkf84xta14wt" />} label="Analytics" onClick={() => setActiveSection('analytics')} data-id="element-5425" data-mp="fkar96ogi862" />
            </div>
            <div className="pt-4 border-t border-gray-200" data-id="element-5427" data-mp="pk1ld793ul5m">
              <h3 className="text-xs font-medium text-gray-500 uppercase mb-3" data-id="element-5428" data-mp="phfc936kfxla">
                Related
              </h3>
              <div className="space-y-1" data-id="element-5429" data-mp="3t08ewkxt320o">
                <button className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md" onClick={() => setShowNotes(!showNotes)} data-id="element-5430" data-mp="3t108jq7uepob">
                  <StickyNoteIcon size={16} className="mr-3" data-id="element-5431" data-mp="6kw34dvri9oq" />
                  Notes
                  <span className="ml-auto bg-gray-100 text-gray-600 text-xs rounded-full px-2 py-0.5 min-w-[1.25rem] text-center" data-id="element-5432" data-mp="35b5y1fazxd78">
                    {quote.notes.length}
                  </span>
                </button>
                <button className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md" onClick={() => setShowHistory(!showHistory)} data-id="element-5433" data-mp="1rdl0t33j0ofq">
                  <HistoryIcon size={16} className="mr-3" data-id="element-5434" data-mp="1id5021e63vek" />
                  History
                </button>
              </div>
            </div>
          </div>
          <div className="mt-auto p-4 border-t border-gray-200" data-id="element-5435" data-mp="18fqmqanjjmqh">
            <div className="flex flex-col space-y-2" data-id="element-5436" data-mp="18hbghy2171na">
              <button onClick={onEdit} className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-5437" data-mp="13oie3gu1c5ed">
                <PencilIcon size={16} className="mr-2" data-id="element-5438" data-mp="zl2i8mpsi92q" />
                Edit Quote
              </button>
              <button className="flex items-center justify-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-5439" data-mp="umiv4izgmr8s">
                <SendIcon size={16} className="mr-2" data-id="element-5440" data-mp="kqpiz0pnkzrj" />
                Send Quote
              </button>
            </div>
          </div>
        </div>}
      {/* Main content area */}
      <div className="flex-1 flex flex-col h-full overflow-hidden" data-id="element-5441" data-mp="g2g3yizxaxlo">
        {/* Top header */}
        <header className="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between" data-id="element-5442" data-mp="22x8apoateq9">
          {!showSidebar && <button onClick={() => setShowSidebar(true)} className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-5443" data-mp="63qxrnhe31l9">
              <ChevronRightIcon size={20} data-id="element-5444" data-mp="tv4nrms2il32" />
            </button>}
          <div className="flex-1" data-id="element-5445" data-mp="yr3al5xqzv1d">
            <h1 className="text-xl font-semibold text-gray-900" data-id="element-5446" data-mp="yu8ve8zcgara">
              {quote.title}
            </h1>
            <p className="text-sm text-gray-500 mt-0.5" data-id="element-5447" data-mp="kyx1g3t0iobf">{quote.description}</p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-5448" data-mp="ozyt9zklny3d">
            <span className={`px-3 py-1 rounded-full text-xs font-medium flex items-center ${getStatusConfig(quote.status).color}`} data-id="element-5449" data-mp="1cquq5b3wxjhh">
              {getStatusConfig(quote.status).icon}
              <span className="ml-1.5" data-id="element-5450" data-mp="3289i3t8f758z">
                {getStatusConfig(quote.status).label}
              </span>
            </span>
            <div className="flex items-center ml-4" data-id="element-5451" data-mp="2x9f02tia1kpx">
              <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-5452" data-mp="3bzdwaqq9um2r">
                <DownloadIcon size={18} data-id="element-5453" data-mp="36z84nak04zko" />
              </button>
              <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-5454" data-mp="372408s8dnc5y">
                <PrinterIcon size={18} data-id="element-5455" data-mp="2jc075esteut7" />
              </button>
              <div className="relative" ref={shareMenuRef} data-id="element-5456" data-mp="2ecnbc4jyudeh">
                <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setShowShareMenu(!showShareMenu)} data-id="element-5457" data-mp="2t8w88zgdwenq">
                  <ShareIcon size={18} data-id="element-5458" data-mp="2o7yucz2eq6s1" />
                </button>
                {showShareMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-10" data-id="element-5459" data-mp="8gkmmp0m6hdv">
                    <div className="py-1" data-id="element-5460" data-mp="3l5aq2m62vk3">
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5461" data-mp="1x2je52ikf71v">
                        <LinkIcon size={14} className="mr-2 text-gray-500" data-id="element-5462" data-mp="221mkqre71lby" />
                        Copy link
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5463" data-mp="26y4mrji535kl">
                        <MailIcon size={14} className="mr-2 text-gray-500" data-id="element-5464" data-mp="2gq0wjrtl8k4n" />
                        Email quote
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5465" data-mp="2kq1894payh80">
                        <ExternalLinkIcon size={14} className="mr-2 text-gray-500" data-id="element-5466" data-mp="2pr8gf4vcxif7" />
                        Open public view
                      </button>
                    </div>
                  </div>}
              </div>
              <div className="relative" ref={actionMenuRef} data-id="element-5467" data-mp="veqymctafahy">
                <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setShowActionMenu(!showActionMenu)} data-id="element-5468" data-mp="10c0zcom4n8l3">
                  <MoreHorizontalIcon size={18} data-id="element-5469" data-mp="o1jd1pd316e4" />
                </button>
                {showActionMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-10" data-id="element-5470" data-mp="j1x2xosjw69j">
                    <div className="py-1" data-id="element-5471" data-mp="e3vawed5cwlx">
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5472" data-mp="e0zamjdttvub">
                        <CopyIcon size={14} className="mr-2 text-gray-500" data-id="element-5473" data-mp="16rrfe58yjst9" />
                        Duplicate
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5474" data-mp="11rmwy9ohoo0e">
                        <ArchiveIcon size={14} className="mr-2 text-gray-500" data-id="element-5475" data-mp="wt1us4pofu9b" />
                        Archive
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5476" data-mp="3hjslgof806ks">
                        <RefreshCwIcon size={14} className="mr-2 text-gray-500" data-id="element-5477" data-mp="2hctrvwug4lvh" />
                        Refresh
                      </button>
                      <div className="border-t border-gray-200 my-1" data-id="element-5478" data-mp="2ckabyt8adeni"></div>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-5479" data-mp="27njwa70e8l2m">
                        <TrashIcon size={14} className="mr-2" data-id="element-5480" data-mp="22p0bi9xjdfbu" />
                        Delete
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </header>
        {/* Main scrollable content */}
        <div className="flex-1 overflow-auto" data-id="element-5481" data-mp="2qbyouyqd075j">
          <div className="max-w-6xl mx-auto p-6" data-id="element-5482" data-mp="2qeul8imk6nrv">
            {/* Overview Section - Redesigned for print */}
            {activeSection === 'overview' && <div data-id="element-5483" data-mp="1ey35fdsf9c8i">
                {/* Template Selector and Print buttons */}
                <div className="print:hidden mb-6 flex justify-between items-center" data-id="element-5484" data-mp="1avq3l0gspyh0">
                  <div className="relative" ref={templateSelectorRef} data-id="element-5485" data-mp="3mjl3ei23yofk">
                    <button onClick={toggleTemplateSelector} className="flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-5486" data-mp="3mhi6rf6g9x1v">
                      <LayoutIcon size={16} className="mr-2 text-blue-600" data-id="element-5487" data-mp="3viyibq90457o" />
                      Cambiar Plantilla
                      <ChevronDownIcon size={16} className="ml-2 text-gray-500" data-id="element-5488" data-mp="47gdbkzkn17r" />
                    </button>
                    {showTemplateSelector && <div className="absolute left-0 mt-2 w-[600px] bg-white rounded-md shadow-lg border border-gray-200 z-20" data-id="element-5489" data-mp="e305pxexfhrr">
                        <div className="p-4 border-b border-gray-200" data-id="element-5490" data-mp="i5whp59yofmq">
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-5491" data-mp="n4pxx5gmukql">
                            Seleccionar Plantilla
                          </h3>
                          <p className="text-sm text-gray-500 mt-1" data-id="element-5492" data-mp="2jz48bav0yjnx">
                            Elige entre nuestras plantillas predefinidas para tu
                            cotización
                          </p>
                        </div>
                        <div className="grid grid-cols-3 gap-4 p-4" data-id="element-5493" data-mp="3n8p33fmdudyl">
                          {/* Plantilla Estándar */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'standard' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('standard')} data-id="element-5494" data-mp="53lrrd5tp5pq">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5495" data-mp="a02imf4epy6i">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5496" data-mp="nrh2spa1w5f5">
                                <div className="h-6 bg-gray-200 rounded mb-2" data-id="element-5497" data-mp="jrqdyr433zd9"></div>
                                <div className="flex-1 flex" data-id="element-5498" data-mp="xrhouizb0zn1">
                                  <div className="w-1/2 pr-1" data-id="element-5499" data-mp="srv65u0pir6u">
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5500" data-mp="spijj3k07sng"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1" data-id="element-5501" data-mp="1ce6n6hhtl6ru"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5502" data-mp="1hbzs777dzuqj"></div>
                                  </div>
                                  <div className="w-1/2 pl-1" data-id="element-5503" data-mp="17ebuc8ehi745">
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5504" data-mp="17cqz0gkcik58"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1" data-id="element-5505" data-mp="tlcg09qfuiy6"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5506" data-mp="yefbwoiou4hj"></div>
                                  </div>
                                </div>
                                <div className="h-12 bg-gray-200 rounded mt-2" data-id="element-5507" data-mp="onaw5ml6ufln"></div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5508" data-mp="aoup1ujeyn2z">
                              <h4 className="font-medium text-gray-900" data-id="element-5509" data-mp="epwhnsits0vz">
                                Plantilla Estándar
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5510" data-mp="7oas8oyc0vjd">
                                Diseño profesional y equilibrado
                              </p>
                              {selectedTemplate === 'standard' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5511" data-mp="3p2y28lap6h9r">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5512" data-mp="3l132hl8f0by3" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                          {/* Plantilla Profesional */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'professional' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('professional')} data-id="element-5513" data-mp="3b500cfdkcdb5">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5514" data-mp="14amgmauxgjzw">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5515" data-mp="1crn33cd2hrlk">
                                <div className="h-8 bg-blue-100 rounded mb-2 flex items-center p-1" data-id="element-5516" data-mp="1lm1f962awm0g">
                                  <div className="h-4 w-4 rounded-full bg-blue-200 mr-2" data-id="element-5517" data-mp="1ql4korm70u8y"></div>
                                  <div className="h-3 bg-blue-200 rounded w-1/3" data-id="element-5518" data-mp="tuveqoio4man"></div>
                                </div>
                                <div className="flex-1 flex" data-id="element-5519" data-mp="xvp0pccjvr0w">
                                  <div className="w-full" data-id="element-5520" data-mp="xya4i6wesh1a">
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5521" data-mp="12us8h4jx0bck"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5522" data-mp="17vfwrigree33"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5523" data-mp="2e9nmqpengasl"></div>
                                    <div className="h-6 bg-gray-100 rounded mt-2 mb-1" data-id="element-5524" data-mp="2j8qre8qpwf01"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5525" data-mp="1tkv1uytmj5ry"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5526" data-mp="1oncrr53vekid"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5527" data-mp="1ylirbg27fek2">
                              <h4 className="font-medium text-gray-900" data-id="element-5528" data-mp="1auddf6ftqwce">
                                Plantilla Profesional
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5529" data-mp="15u8vdbz9ptk2">
                                Diseño formal con detalles completos
                              </p>
                              {selectedTemplate === 'professional' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5530" data-mp="s4ow4g4wbefi">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5531" data-mp="n5u1mgxkg1fk" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                          {/* Plantilla Minimalista */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'minimalist' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('minimalist')} data-id="element-5532" data-mp="2ourmnnb98c8b">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5533" data-mp="3hhcbag0cia86">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5534" data-mp="3mgfh42o5gkh7">
                                <div className="h-8 flex items-center justify-between mb-3" data-id="element-5535" data-mp="3ckc9ihaj3tmv">
                                  <div className="h-4 w-1/4 bg-gray-200 rounded" data-id="element-5536" data-mp="1x3lh2rcrlmbn"></div>
                                  <div className="h-4 w-1/4 bg-gray-800 rounded" data-id="element-5537" data-mp="1x5y8rw8brb1w"></div>
                                </div>
                                <div className="h-px bg-gray-200 w-full mb-3" data-id="element-5538" data-mp="2ssi96plmpyje"></div>
                                <div className="flex-1" data-id="element-5539" data-mp="2ntneapae0jix">
                                  <div className="h-3 bg-gray-200 rounded mb-2 w-1/2" data-id="element-5540" data-mp="2ns3wuvczw2fk"></div>
                                  <div className="h-3 bg-gray-200 rounded mb-2 w-3/4" data-id="element-5541" data-mp="2jsv3hrlva6kj"></div>
                                  <div className="h-3 bg-gray-200 rounded w-1/3" data-id="element-5542" data-mp="2eu0mmv7gms32"></div>
                                </div>
                                <div className="h-px bg-gray-200 w-full mt-3 mb-3" data-id="element-5543" data-mp="3bige4wu4rbit"></div>
                                <div className="h-4 bg-gray-800 rounded w-1/4 ml-auto" data-id="element-5544" data-mp="37i69bni2qr5j"></div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5545" data-mp="2xscxcle0sa0r">
                              <h4 className="font-medium text-gray-900" data-id="element-5546" data-mp="2xpqpekn7vsi0">
                                Plantilla Minimalista
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5547" data-mp="3qfh5gz8et4gr">
                                Diseño limpio, simple y directo
                              </p>
                              {selectedTemplate === 'minimalist' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5548" data-mp="6m57nj4pqaao">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5549" data-mp="bivo47kfj7wm" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                        </div>
                        {/* Banner premium */}
                        <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 border-t border-amber-200" data-id="element-5550" data-mp="pin9itd9zqkn">
                          <div className="flex items-center" data-id="element-5551" data-mp="ud16v1bi07ry">
                            <div className="mr-4 flex-shrink-0" data-id="element-5552" data-mp="z8ztokh6hhq9">
                              <div className="h-12 w-12 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-5553" data-mp="13bwfsl5xfvyy">
                                <CrownIcon size={24} className="text-amber-600" data-id="element-5554" data-mp="189xyh4zfxt9w" />
                              </div>
                            </div>
                            <div data-id="element-5555" data-mp="2b1y3t7i2e0yl">
                              <h4 className="font-medium text-gray-900" data-id="element-5556" data-mp="2f1yeqi5yfu0w">
                                Personaliza con tu marca
                              </h4>
                              <p className="text-sm text-gray-600 mt-1" data-id="element-5557" data-mp="213s3uvftj4wd">
                                Contrata Aisco Workspace Premium y obtén
                                plantillas personalizadas con el logo y colores
                                de tu empresa.
                              </p>
                              <button className="mt-2 text-sm px-3 py-1 bg-amber-500 text-white rounded-md hover:bg-amber-600 transition-colors inline-flex items-center" data-id="element-5558" data-mp="2yr8t9stys8xf">
                                <CrownIcon size={14} className="mr-1" data-id="element-5559" data-mp="2oy1p2baymyyx" />
                                Conocer Premium
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>}
                  </div>
                  <button onClick={handlePrintQuote} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-5560" data-mp="15zdj3fe5qafa">
                    <PrinterIcon size={16} className="mr-2" data-id="element-5561" data-mp="1eti9xytajlut" />
                    Imprimir Cotización
                  </button>
                </div>
                {/* Plantilla Estándar */}
                {selectedTemplate === 'standard' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5562" data-mp="n2m5nmlaqpj5">
                    {/* Quote Header */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5563" data-mp="w30s4p9zyao8">
                      <div className="flex justify-between items-start" data-id="element-5564" data-mp="r3ny9kkpk3c5">
                        <div data-id="element-5565" data-mp="r5sacpsrg8ni">
                          <div className="h-16 w-40 bg-gray-100 flex items-center justify-center rounded mb-4" data-id="element-5566" data-mp="27hnsqg0sb0s0">
                            <FileTextIcon size={32} className="text-gray-400" data-id="element-5567" data-mp="22jckg9q50ybw" />
                          </div>
                          <h2 className="text-2xl font-bold text-gray-900" data-id="element-5568" data-mp="10681pl6crjaf">
                            Valley Irrigation
                          </h2>
                          <p className="text-gray-600" data-id="element-5569" data-mp="156cg95npa3y0">
                            123 Corporate Way, Omaha, NE 68137
                          </p>
                          <p className="text-gray-600" data-id="element-5570" data-mp="1e44wqd55rhmz">
                            +1 (800) 825-6668 | info@valleyirrigation.com
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5571" data-mp="lfqz3yhzenby">
                          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-5572" data-mp="lefww346pnmy">
                            COTIZACIÓN
                          </h1>
                          <div className="text-gray-600" data-id="element-5573" data-mp="v6lovcufs525">
                            <p data-id="element-5574" data-mp="v86dklu2kts3">
                              <span className="font-medium" data-id="element-5575" data-mp="3tx3wo65smdvu">Cotización #:</span>{' '}
                              {quote.id}
                            </p>
                            <p data-id="element-5576" data-mp="2nods9ueaivd">
                              <span className="font-medium" data-id="element-5577" data-mp="3rcfly7ww4qt4">Fecha:</span>{' '}
                              {quote.date}
                            </p>
                            <p data-id="element-5578" data-mp="3mdmbypgtbhxp">
                              <span className="font-medium" data-id="element-5579" data-mp="3hdgbqkwh8n40">Válido hasta:</span>{' '}
                              {quote.expiresIn}
                            </p>
                            <p className={`mt-2 font-medium ${expiryStatus.color}`} data-id="element-5580" data-mp="3dbv69km9vb3u">
                              {expiryStatus.label}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Customer & Quote Information */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5581" data-mp="2tofcno9jaobe">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5582" data-mp="2tm2lckhvz1lo">
                        <div data-id="element-5583" data-mp="2pm0u759s1qkn">
                          <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-5584" data-mp="2pod7340ohaqu">
                            Información del Cliente
                          </h3>
                          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5585" data-mp="okuij1di94xk">
                            <p className="font-medium text-gray-800" data-id="element-5586" data-mp="sm61io1virws">
                              {quote.customer}
                            </p>
                            <p className="text-gray-600" data-id="element-5587" data-mp="esf1c6a18kdq">{quote.company}</p>
                            <p className="text-gray-600" data-id="element-5588" data-mp="js1e6ely7ym0">
                              {quote.companyAddress}
                            </p>
                            <div className="mt-3" data-id="element-5589" data-mp="9vew1xl0blno">
                              <p className="text-gray-600" data-id="element-5590" data-mp="9wzqln7bn4lj">
                                <span className="font-medium" data-id="element-5591" data-mp="3s1ktluny2864">Email:</span>{' '}
                                {quote.customerEmail}
                              </p>
                              <p className="text-gray-600" data-id="element-5592" data-mp="wl3ciasrffe">
                                <span className="font-medium" data-id="element-5593" data-mp="1qazoksmlwk65">Teléfono:</span>{' '}
                                {quote.customerPhone}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-5594" data-mp="20dv8bry4ia9z">
                          <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-5595" data-mp="20eo8ub6ho3jo">
                            Detalles de la Cotización
                          </h3>
                          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5596" data-mp="29ejj8ds7zuin">
                            <h4 className="font-medium text-gray-800 text-lg mb-2" data-id="element-5597" data-mp="29cgm79snh14f">
                              {quote.title}
                            </h4>
                            <p className="text-gray-600 mb-3" data-id="element-5598" data-mp="2j3b8ge5wc0pv">
                              {quote.description}
                            </p>
                            <div className="grid grid-cols-2 gap-4" data-id="element-5599" data-mp="2x1jah0hshs7w">
                              <div data-id="element-5600" data-mp="2t2sgv3cj8spj">
                                <p className="text-gray-600" data-id="element-5601" data-mp="12pux32r7hxpm">
                                  <span className="font-medium" data-id="element-5602" data-mp="12q4n2qc944vb">Región:</span>{' '}
                                  {quote.region}
                                </p>
                                <p className="text-gray-600" data-id="element-5603" data-mp="2xtssk2cwj1k0">
                                  <span className="font-medium" data-id="element-5604" data-mp="32s46ao6bhw7i">País:</span>{' '}
                                  {quote.country}
                                </p>
                              </div>
                              <div data-id="element-5605" data-mp="3cqa7t4o7p0bu">
                                <p className="text-gray-600" data-id="element-5606" data-mp="3crbhb4pkxerg">
                                  <span className="font-medium" data-id="element-5607" data-mp="3grveg8a5kidl">
                                    Cotizado por:
                                  </span>{' '}
                                  {quote.quotedBy}
                                </p>
                                <p className="text-gray-600" data-id="element-5608" data-mp="3qizrh2g9pt5s">
                                  <span className="font-medium" data-id="element-5609" data-mp="3vgi2cyduiigf">
                                    Gerente de Ventas:
                                  </span>{' '}
                                  {quote.salesManager}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Quote Items */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5610" data-mp="1ouvldkboze69">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-5611" data-mp="1jty3l8ulgm5a">
                        Artículos de la Cotización
                      </h3>
                      <div className="overflow-x-auto" data-id="element-5612" data-mp="2cili8lku8d9v">
                        <table className="min-w-full divide-y divide-gray-200" data-id="element-5613" data-mp="2ck6dyeiw229b">
                          <thead data-id="element-5614" data-mp="27jio3w6ebrgo">
                            <tr className="bg-gray-50" data-id="element-5615" data-mp="22safv3gsyc53">
                              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5616" data-mp="22qz9cvvz2qaa">
                                Descripción del Artículo
                              </th>
                              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5617" data-mp="2vao183kyc5na">
                                Cantidad
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5618" data-mp="23l093rxq0njj">
                                Precio Unitario
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5619" data-mp="1tup0vt707s6u">
                                Descuento
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5620" data-mp="2mitcswg651hz">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200" data-id="element-5621" data-mp="x4eq0hopnop4">
                            {quote.items.map(item => <tr key={item.id} data-id="element-5622" data-mp="124awqooslu8d">
                                <td className="px-6 py-4" data-id="element-5623" data-mp="121y3vghhxzgj">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-5624" data-mp="tlz63m9apcv2">
                                    {item.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-5625" data-mp="13ky7qkvn888k">
                                    {item.description}
                                  </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5626" data-mp="avzmhew84pz1">
                                  {item.quantity}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5627" data-mp="kmu8ci5k5njy">
                                  {formatCurrency(item.unitPrice)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5628" data-mp="3oanleukm1nzo">
                                  {item.discount > 0 ? `${item.discount}%` : '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5629" data-mp="2kjskwm68yxc1">
                                  {formatCurrency(item.total)}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* Quote Summary */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5630" data-mp="20v9zmfod442m">
                      <div className="flex justify-end" data-id="element-5631" data-mp="1wx2hbge92upb">
                        <div className="w-full md:w-1/2 lg:w-1/3" data-id="element-5632" data-mp="2amw6y0xkxj03">
                          <div className="space-y-2" data-id="element-5633" data-mp="2ap8y94p895pt">
                            <div className="flex justify-between text-sm" data-id="element-5634" data-mp="25w7dig2cabyb">
                              <span className="text-gray-600" data-id="element-5635" data-mp="1i6lhg1h9kcuj">Subtotal:</span>
                              <span className="text-gray-800 font-medium" data-id="element-5636" data-mp="1i4igwnihj1bk">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm" data-id="element-5637" data-mp="3tmdocb4adl87">
                                <span className="text-gray-600" data-id="element-5638" data-mp="3fuflgi164lkh">
                                  Descuento ({quote.discount}%):
                                </span>
                                <span className="text-green-600 font-medium" data-id="element-5639" data-mp="3kts74zgazmlh">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm" data-id="element-5640" data-mp="2erc3u3i4afq">
                              <span className="text-gray-600" data-id="element-5641" data-mp="7e47j38fuptx">
                                Impuesto ({quote.tax}%):
                              </span>
                              <span className="text-gray-800 font-medium" data-id="element-5642" data-mp="2n7uuhiolubhg">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-5643" data-mp="284l332fefdg4">
                              <div className="flex justify-between text-base" data-id="element-5644" data-mp="2439jpen4bogd">
                                <span className="font-medium text-gray-800" data-id="element-5645" data-mp="1z8viuwposp4b">
                                  Total:
                                </span>
                                <span className="font-bold text-blue-600" data-id="element-5646" data-mp="1pcs6ky14fa3n">
                                  {formatCurrency(quote.total)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Terms & Payment */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5647" data-mp="3aq52bj8tfh5m">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5648" data-mp="3an94duwywsh6">
                        <div data-id="element-5649" data-mp="35ra87l5ee667">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5650" data-mp="3da1bzr5cqeao">
                            Condiciones de Pago
                          </h3>
                          <p className="text-gray-600" data-id="element-5651" data-mp="3i7jm3kv3uzk9">{quote.paymentTerms}</p>
                        </div>
                        <div data-id="element-5652" data-mp="3n0mis1v6ip4o">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5653" data-mp="3ryxruadngvlu">
                            Condiciones de Entrega
                          </h3>
                          <p className="text-gray-600" data-id="element-5654" data-mp="2ud05u302a855">{quote.deliveryTerms}</p>
                        </div>
                        <div data-id="element-5655" data-mp="2zccumtahtpad">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5656" data-mp="349lfj1n107fb">
                            Validez de la Cotización
                          </h3>
                          <p className="text-gray-600" data-id="element-5657" data-mp="388u5rwiuxn64">
                            {quote.validityPeriod}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Notes & Terms */}
                    <div className="p-8" data-id="element-5658" data-mp="m4lo4hg8j8jb">
                      <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5659" data-mp="m5dgzkig6s5w">
                        Notas y Términos
                      </h3>
                      <p className="text-gray-600 mb-6" data-id="element-5660" data-mp="w2rlclr3jqhu">{quote.terms}</p>
                      <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-5661" data-mp="r2wswdroasuo">
                        <div className="grid grid-cols-2 gap-8" data-id="element-5662" data-mp="r4zvrydxcggt">
                          <div data-id="element-5663" data-mp="1513il6mgxmj9">
                            <h4 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-5664" data-mp="1501wm73wzfmr">
                              Aceptación del Cliente
                            </h4>
                            <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5665" data-mp="1eroj4zlpd14t"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5666" data-mp="19u66ay4ke1rj">Firma</p>
                            <div className="h-px bg-gray-300 mb-1 mt-6 w-full" data-id="element-5667" data-mp="1nse8plkddva3"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5668" data-mp="1jraqwtirhp68">Fecha</p>
                          </div>
                          <div data-id="element-5669" data-mp="22fusw36oklrz">
                            <h4 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-5670" data-mp="22gnyv1xtf792">
                              Representante de Valley Irrigation
                            </h4>
                            <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5671" data-mp="1tfpw0mz455s2"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5672" data-mp="1ydrfh90gb742">Firma</p>
                            <div className="h-px bg-gray-300 mb-1 mt-6 w-full" data-id="element-5673" data-mp="1yg423zh5m5ng"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5674" data-mp="1jnsk1e0a69sa">Fecha</p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-12 text-center text-gray-500 text-sm" data-id="element-5675" data-mp="1ap87kulbcwci">
                        <p data-id="element-5676" data-mp="1epqxuk7k5ucl">¡Gracias por su preferencia!</p>
                        <p data-id="element-5677" data-mp="1eqaapmicpsjr">
                          Para cualquier consulta sobre esta cotización,
                          contáctenos en {quote.customerEmail}
                        </p>
                      </div>
                    </div>
                  </div>}
                {/* Plantilla Profesional */}
                {selectedTemplate === 'professional' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5678" data-mp="32njde7v76in3">
                    {/* Encabezado con color */}
                    <div className="bg-blue-600 text-white p-8" data-id="element-5679" data-mp="2tnd3sx2me2t7">
                      <div className="flex justify-between items-center" data-id="element-5680" data-mp="2toxw0g1gp9nw">
                        <div className="flex items-center" data-id="element-5681" data-mp="3qc2oev5mt9iv">
                          <div className="h-16 w-16 bg-white rounded-full flex items-center justify-center mr-4" data-id="element-5682" data-mp="3mc1yoed31bwi">
                            <FileTextIcon size={32} className="text-blue-600" data-id="element-5683" data-mp="3hbwe1i58cpnx" />
                          </div>
                          <div data-id="element-5684" data-mp="3ccjgo3gqg073">
                            <h1 className="text-3xl font-bold" data-id="element-5685" data-mp="3cdclv001mhn4">COTIZACIÓN</h1>
                            <p className="text-blue-100 mt-1" data-id="element-5686" data-mp="25ybu76i1wlmc">
                              Soluciones de Irrigación de Precisión
                            </p>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-5687" data-mp="1qsedghm37i1y">
                          <div className="inline-block bg-blue-700 rounded-lg px-4 py-2" data-id="element-5688" data-mp="1vsspeaqt7c59">
                            <p className="text-blue-100 text-sm" data-id="element-5689" data-mp="20s5buudrqh7b">
                              Cotización #
                            </p>
                            <p className="text-xl font-bold" data-id="element-5690" data-mp="25kpztf9zu02x">{quote.id}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Información de la empresa y cliente */}
                    <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5691" data-mp="2jimzikjqumlt">
                      <div data-id="element-5692" data-mp="2oi99ml49zmqe">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5693" data-mp="2oij52o83am3h">
                          DATOS DE LA EMPRESA
                        </h2>
                        <div className="space-y-2" data-id="element-5694" data-mp="u3q8alvgzp9y">
                          <p className="text-lg font-semibold text-gray-800" data-id="element-5695" data-mp="u4i49xszbp0r">
                            Valley Irrigation
                          </p>
                          <p className="text-gray-600" data-id="element-5696" data-mp="2r3h322ank287">123 Corporate Way</p>
                          <p className="text-gray-600" data-id="element-5697" data-mp="35rlld55smbqg">Omaha, NE 68137</p>
                          <p className="text-gray-600" data-id="element-5698" data-mp="35toazo31a2un">Estados Unidos</p>
                          <p className="text-gray-600" data-id="element-5699" data-mp="30ttk3kj9dd9l">+1 (800) 825-6668</p>
                          <p className="text-gray-600" data-id="element-5700" data-mp="2d24nvt3bg4nd">
                            info@valleyirrigation.com
                          </p>
                          <p className="text-gray-600" data-id="element-5701" data-mp="285nxstck3g7n">
                            www.valleyirrigation.com
                          </p>
                        </div>
                      </div>
                      <div data-id="element-5702" data-mp="2i0po3sikiobt">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5703" data-mp="1ddfe50ix2gf">
                          CLIENTE
                        </h2>
                        <div className="space-y-2" data-id="element-5704" data-mp="3tgwi8bk0vlzb">
                          <p className="text-lg font-semibold text-gray-800" data-id="element-5705" data-mp="4urmaqfd4hq4">
                            {quote.customer}
                          </p>
                          <p className="text-gray-600" data-id="element-5706" data-mp="9sb1ptnsr0jn">{quote.company}</p>
                          <p className="text-gray-600" data-id="element-5707" data-mp="3r3svl09iguqg">
                            {quote.companyAddress}
                          </p>
                          <p className="text-gray-600" data-id="element-5708" data-mp="3w3fade4zmj1d">
                            <span className="font-medium" data-id="element-5709" data-mp="nn3ptghr5p1u">Email:</span>{' '}
                            {quote.customerEmail}
                          </p>
                          <p className="text-gray-600" data-id="element-5710" data-mp="dvzecqracmbr">
                            <span className="font-medium" data-id="element-5711" data-mp="dvg29qobgs5n">Teléfono:</span>{' '}
                            {quote.customerPhone}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Información de la cotización */}
                    <div className="px-8 py-6 bg-gray-50 border-t border-b border-gray-200" data-id="element-5712" data-mp="1bcxzjp6ryxhv">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-5713" data-mp="2dam6hl5j13au">
                        <div data-id="element-5714" data-mp="2i9p7muidypdj">
                          <p className="text-sm text-gray-500" data-id="element-5715" data-mp="2i8nsoey91iqj">
                            FECHA DE EMISIÓN
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5716" data-mp="2s00kx7nymax3">
                            {quote.date}
                          </p>
                        </div>
                        <div data-id="element-5717" data-mp="1uemewbggo1rs">
                          <p className="text-sm text-gray-500" data-id="element-5718" data-mp="1zbct0t8pgnak">VÁLIDA HASTA</p>
                          <p className="font-medium text-gray-800" data-id="element-5719" data-mp="1zdft663knwt0">
                            {quote.expiresIn}
                          </p>
                        </div>
                        <div data-id="element-5720" data-mp="29bdg8q9p3nk1">
                          <p className="text-sm text-gray-500" data-id="element-5721" data-mp="297fxi5r14y0o">COTIZADO POR</p>
                          <p className="font-medium text-gray-800" data-id="element-5722" data-mp="3fpl1jjwn4w37">
                            {quote.quotedBy}
                          </p>
                        </div>
                        <div data-id="element-5723" data-mp="190ar16p1l5eb">
                          <p className="text-sm text-gray-500" data-id="element-5724" data-mp="193ot0dtsncl8">
                            CONDICIONES DE PAGO
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5725" data-mp="zb99vd6rghyr">
                            {quote.paymentTerms}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Descripción del proyecto */}
                    <div className="p-8" data-id="element-5726" data-mp="lc1d0qy2llxq">
                      <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5727" data-mp="lb8ci7ppfso1">
                        DESCRIPCIÓN DEL PROYECTO
                      </h2>
                      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6" data-id="element-5728" data-mp="ben7vnhlkjkq">
                        <h3 className="font-semibold text-lg text-gray-900 mb-2" data-id="element-5729" data-mp="2ar7qq386k8aj">
                          {quote.title}
                        </h3>
                        <p className="text-gray-700" data-id="element-5730" data-mp="25ps446qcttq1">{quote.description}</p>
                      </div>
                      {/* Items de la cotización */}
                      <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5731" data-mp="8uh1za9faj1j">
                        DETALLE DE PRODUCTOS Y SERVICIOS
                      </h2>
                      <div className="overflow-x-auto" data-id="element-5732" data-mp="3v87821jsj0nr">
                        <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden" data-id="element-5733" data-mp="3v6noo22u89hr">
                          <thead data-id="element-5734" data-mp="rs9tzhiid8k5">
                            <tr className="bg-blue-600 text-white" data-id="element-5735" data-mp="rsjmbbr0zrt0">
                              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" data-id="element-5736" data-mp="cv0ycbm69imm">
                                Descripción
                              </th>
                              <th scope="col" className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider" data-id="element-5737" data-mp="2xlhx32741dpr">
                                Cantidad
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5738" data-mp="1kmg1ip4gevbn">
                                Precio Unitario
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5739" data-mp="1tnwe93iqr9j1">
                                Descuento
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5740" data-mp="11voy0475dz56">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200" data-id="element-5741" data-mp="1aqmpd6und3ue">
                            {quote.items.map((item, index) => <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-5742" data-mp="i87o63a6xue0" data-mpi={index}>
                                <td className="px-6 py-4" data-id="element-5743" data-mp="e6vw7r3ugx2n">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-5744" data-mp="e6ds68axxek6">
                                    {item.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-5745" data-mp="vvzmrr2xjshb">
                                    {item.description}
                                  </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5746" data-mp="15lj7z3e47yfc">
                                  {item.quantity}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5747" data-mp="1ek4nsqs7czcf">
                                  {formatCurrency(item.unitPrice)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5748" data-mp="1oj3q7rmdjyqz">
                                  {item.discount > 0 ? `${item.discount}%` : '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5749" data-mp="3qctf0zdnur2q">
                                  {formatCurrency(item.total)}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                      {/* Resumen de la cotización */}
                      <div className="mt-8 flex justify-end" data-id="element-5750" data-mp="5kxmc8yx0in6">
                        <div className="w-full md:w-1/2 lg:w-2/5 bg-gray-50 border border-gray-200 rounded-lg p-6" data-id="element-5751" data-mp="5kfior9xb258">
                          <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-300" data-id="element-5752" data-mp="jrs26plwnbj">
                            RESUMEN DE LA COTIZACIÓN
                          </h3>
                          <div className="space-y-3" data-id="element-5753" data-mp="3mssy87ogkk7n">
                            <div className="flex justify-between text-sm" data-id="element-5754" data-mp="2gd8uvf7esw1a">
                              <span className="text-gray-600" data-id="element-5755" data-mp="2be5pftnionss">Subtotal:</span>
                              <span className="text-gray-800 font-medium" data-id="element-5756" data-mp="2bg8pz7mapzbr">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm" data-id="element-5757" data-mp="tgsk15ukfuwg">
                                <span className="text-gray-600" data-id="element-5758" data-mp="yfdlt9pgumn0">
                                  Descuento ({quote.discount}%):
                                </span>
                                <span className="text-green-600 font-medium" data-id="element-5759" data-mp="jp6d3lp9ghzi">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm" data-id="element-5760" data-mp="fpxh0a6r080s">
                              <span className="text-gray-600" data-id="element-5761" data-mp="r3kkwxi82wy">
                                Impuesto ({quote.tax}%):
                              </span>
                              <span className="text-gray-800 font-medium" data-id="element-5762" data-mp="5ssu2852w8ix">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="border-t border-gray-300 pt-3 mt-3" data-id="element-5763" data-mp="3eb1yqhuq2393">
                              <div className="flex justify-between" data-id="element-5764" data-mp="3s9rsbnic1ksp">
                                <span className="font-bold text-gray-800 text-lg" data-id="element-5765" data-mp="3n8m0rt0es3kr">
                                  TOTAL:
                                </span>
                                <span className="font-bold text-blue-600 text-xl" data-id="element-5766" data-mp="12far7djf5c9">
                                  {formatCurrency(quote.total)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Términos y condiciones */}
                      <div className="mt-8" data-id="element-5767" data-mp="jsn818uk31kj">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5768" data-mp="jtybt8o049bn">
                          TÉRMINOS Y CONDICIONES
                        </h2>
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-5769" data-mp="35js53n63usz8">
                          <p className="text-gray-700 whitespace-pre-line" data-id="element-5770" data-mp="3ajmrpeiukweh">
                            {quote.terms}
                          </p>
                          <p className="text-gray-700 mt-4" data-id="element-5771" data-mp="3fgwq3jo7sieg">
                            Condiciones de entrega: {quote.deliveryTerms}
                          </p>
                          <p className="text-gray-700" data-id="element-5772" data-mp="2mv3m56r6mxq3">
                            Validez de la oferta: {quote.validityPeriod}
                          </p>
                        </div>
                      </div>
                      {/* Firmas */}
                      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5773" data-mp="1z4r4v5a1romu">
                        <div className="border-t-2 border-gray-300 pt-4" data-id="element-5774" data-mp="1z2wuum0bdgxj">
                          <p className="font-medium text-gray-800" data-id="element-5775" data-mp="2429e6wrz85vd">
                            Aceptación del Cliente
                          </p>
                          <p className="text-gray-500 text-sm" data-id="element-5776" data-mp="h7e3qto4phwb">
                            Nombre, Firma y Fecha
                          </p>
                        </div>
                        <div className="border-t-2 border-gray-300 pt-4" data-id="element-5777" data-mp="c9umrm01qr0o">
                          <p className="font-medium text-gray-800" data-id="element-5778" data-mp="78f4u2t610mi">
                            Por Valley Irrigation
                          </p>
                          <p className="text-gray-500 text-sm" data-id="element-5779" data-mp="3torn571dclxa">
                            Nombre, Firma y Fecha
                          </p>
                        </div>
                      </div>
                      {/* Footer */}
                      <div className="mt-16 pt-8 border-t border-gray-200 text-center" data-id="element-5780" data-mp="3kp4jeel63412">
                        <p className="text-gray-500" data-id="element-5781" data-mp="3fnp0ot6gp9lu">
                          Esta cotización fue generada por Valley Irrigation -
                          Soluciones de Irrigación de Precisión
                        </p>
                        <p className="text-gray-500 mt-1" data-id="element-5782" data-mp="39gj1kqo4xhnh">
                          Para cualquier consulta, contacte a su representante
                          de ventas o visite www.valleyirrigation.com
                        </p>
                      </div>
                    </div>
                  </div>}
                {/* Plantilla Minimalista */}
                {selectedTemplate === 'minimalist' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5783" data-mp="2qk103hjhi3e1">
                    {/* Encabezado minimalista */}
                    <div className="p-8" data-id="element-5784" data-mp="2gtofxqfl0c8f">
                      <div className="flex justify-between items-center" data-id="element-5785" data-mp="2gqaeqlinm92k">
                        <div data-id="element-5786" data-mp="2bv4sfllcasdy">
                          <h1 className="text-2xl font-bold text-gray-900" data-id="element-5787" data-mp="27rysevotlxfx">
                            Cotización
                          </h1>
                          <p className="text-gray-500" data-id="element-5788" data-mp="22twytgtrqfq7">{quote.id}</p>
                        </div>
                        <div className="text-right" data-id="element-5789" data-mp="i9rv4b0wyzky">
                          <div className="h-12 w-36 bg-gray-100 flex items-center justify-center rounded" data-id="element-5790" data-mp="n9watytzzqa4">
                            <FileTextIcon size={24} className="text-gray-400" data-id="element-5791" data-mp="rbraz006zxmb" />
                          </div>
                        </div>
                      </div>
                      <div className="h-px bg-gray-200 w-full my-6" data-id="element-5792" data-mp="w9t2m9bop59e"></div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-5793" data-mp="3vr0ucb9ya5h8">
                        <div data-id="element-5794" data-mp="3l5g6af789u9">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5795" data-mp="3mggg09fqzgm">
                            De
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5796" data-mp="dbqb9nvnyw8f">
                            Valley Irrigation
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5797" data-mp="3c0yvilxsnf9q">
                            123 Corporate Way, Omaha
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5798" data-mp="3gygylvp4r09t">
                            NE 68137, Estados Unidos
                          </p>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-5799" data-mp="j674m572i1fh">
                            info@valleyirrigation.com
                          </p>
                        </div>
                        <div data-id="element-5800" data-mp="swtb99wt3hm1">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5801" data-mp="sxl8sq9yrpey">
                            Para
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5802" data-mp="8e04ygspjfz">
                            {quote.customer}
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5803" data-mp="e98c1r31y2je">
                            {quote.company}
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5804" data-mp="9b6nwrqrrd12">
                            {quote.companyAddress}
                          </p>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-5805" data-mp="1kp0qc5wnylyb">
                            {quote.customerEmail}
                          </p>
                        </div>
                        <div data-id="element-5806" data-mp="1x6lcoiqrhb9t">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5807" data-mp="1x7wcy8l000w6">
                            Detalles
                          </p>
                          <div className="flex justify-between text-sm" data-id="element-5808" data-mp="1j9euoqdv3gln">
                            <span className="text-gray-600" data-id="element-5809" data-mp="1o6oqqovraqig">Fecha:</span>
                            <span className="text-gray-800" data-id="element-5810" data-mp="2bwskm4j57bw9">{quote.date}</span>
                          </div>
                          <div className="flex justify-between text-sm mt-1" data-id="element-5811" data-mp="2gtizwpn4i3gm">
                            <span className="text-gray-600" data-id="element-5812" data-mp="226puqd7bie25">Válido hasta:</span>
                            <span className="text-gray-800" data-id="element-5813" data-mp="274rbusl6o3az">
                              {quote.expiresIn}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm mt-1" data-id="element-5814" data-mp="2usira520swgh">
                            <span className="text-gray-600" data-id="element-5815" data-mp="2zmwq6hfw5lpw">Términos:</span>
                            <span className="text-gray-800" data-id="element-5816" data-mp="1b0k5b01enaz7">
                              {quote.paymentTerms}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Título del proyecto */}
                    <div className="px-8 py-4 bg-gray-50 border-t border-b border-gray-200" data-id="element-5817" data-mp="x11ata1iny5d">
                      <h2 className="text-xl font-medium text-gray-900" data-id="element-5818" data-mp="1umgm5frp44um">
                        {quote.title}
                      </h2>
                      <p className="text-gray-600 mt-1" data-id="element-5819" data-mp="1pqhy5taa4ouq">{quote.description}</p>
                    </div>
                    {/* Items de la cotización - Estilo minimalista */}
                    <div className="p-8" data-id="element-5820" data-mp="1fy2i51ijmach">
                      <table className="min-w-full" data-id="element-5821" data-mp="2ddznzj9zhcv2">
                        <thead data-id="element-5822" data-mp="2dfkemxt6gbnn">
                          <tr className="border-b border-gray-200" data-id="element-5823" data-mp="2dfsqqnhh7cxs">
                            <th scope="col" className="pb-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5824" data-mp="28loim0wh4yv4">
                              Artículo
                            </th>
                            <th scope="col" className="pb-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5825" data-mp="2kxr10u7hes22">
                              Cant.
                            </th>
                            <th scope="col" className="pb-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5826" data-mp="2uwzsngevjul9">
                              Precio
                            </th>
                            <th scope="col" className="pb-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5827" data-mp="33ujqefdj38r4">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody data-id="element-5828" data-mp="3imajo66faam7">
                          {quote.items.map(item => <tr key={item.id} className="border-b border-gray-100" data-id="element-5829" data-mp="3mmufn6f9f86r">
                              <td className="py-4" data-id="element-5830" data-mp="3mkruazp1y38d">
                                <div className="text-sm font-medium text-gray-900" data-id="element-5831" data-mp="1nj5t0204lm7b">
                                  {item.name}
                                </div>
                                <div className="text-xs text-gray-500 mt-1" data-id="element-5832" data-mp="1waeiso847su6">
                                  {item.description}
                                </div>
                              </td>
                              <td className="py-4 text-center text-sm text-gray-500" data-id="element-5833" data-mp="268c2cyf151gg">
                                {item.quantity}
                              </td>
                              <td className="py-4 text-right text-sm text-gray-500" data-id="element-5834" data-mp="21blp0ium0jyq">
                                {formatCurrency(item.unitPrice)}
                                {item.discount > 0 && <span className="text-green-600 text-xs block" data-id="element-5835" data-mp="2b903we0vx0ox">
                                    (-{item.discount}%)
                                  </span>}
                              </td>
                              <td className="py-4 text-right text-sm font-medium text-gray-900" data-id="element-5836" data-mp="gv8pl17m1sn5">
                                {formatCurrency(item.total)}
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                      {/* Resumen minimalista */}
                      <div className="mt-8 border-t border-gray-200 pt-4" data-id="element-5837" data-mp="1z0p0dxnp014">
                        <div className="flex justify-end" data-id="element-5838" data-mp="1wwdpaxfgyqt">
                          <div className="w-48" data-id="element-5839" data-mp="3j62ujcs5ke3z">
                            <div className="flex justify-between text-sm py-2" data-id="element-5840" data-mp="3j9gwwl0tgnbf">
                              <span className="text-gray-600" data-id="element-5841" data-mp="3o7ihjadw4up0">Subtotal</span>
                              <span className="text-gray-800" data-id="element-5842" data-mp="3a7r69herdsep">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm py-2" data-id="element-5843" data-mp="18fujtcr1yy55">
                                <span className="text-gray-600" data-id="element-5844" data-mp="1dcuopkc61uuo">Descuento</span>
                                <span className="text-green-600" data-id="element-5845" data-mp="2lyuzn0ijr6e9">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm py-2" data-id="element-5846" data-mp="2876k0n939zsj">
                              <span className="text-gray-600" data-id="element-5847" data-mp="2853x4c38gms1">
                                Impuesto ({quote.tax}%)
                              </span>
                              <span className="text-gray-800" data-id="element-5848" data-mp="1y7z72169o75y">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="flex justify-between font-medium text-base pt-2 border-t border-gray-200 mt-2" data-id="element-5849" data-mp="1p9dseh3x1cag">
                              <span className="text-gray-800" data-id="element-5850" data-mp="3nn5ptrv8hjpm">Total</span>
                              <span className="text-gray-900" data-id="element-5851" data-mp="3jnetl8mxubdp">
                                {formatCurrency(quote.total)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Notas y términos - Estilo minimalista */}
                    <div className="px-8 py-6 bg-gray-50 border-t border-gray-200" data-id="element-5852" data-mp="1j5r0gh3vp9zj">
                      <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-5853" data-mp="mfq7e5wh87cf">
                        Notas
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-5854" data-mp="rfunhuth3024">{quote.terms}</p>
                    </div>
                    {/* Firma minimalista */}
                    <div className="p-8" data-id="element-5855" data-mp="viivk0ad42y1">
                      <div className="grid grid-cols-2 gap-8" data-id="element-5856" data-mp="10fri0d2jmt53">
                        <div data-id="element-5857" data-mp="10d529q5i17bs">
                          <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5858" data-mp="26wcz5hrzthwv"></div>
                          <p className="text-gray-500 text-xs" data-id="element-5859" data-mp="2buobq09oa6is">
                            Firma del Cliente
                          </p>
                        </div>
                        <div data-id="element-5860" data-mp="32x96kf1yklqq">
                          <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5861" data-mp="37vasr8uol16f"></div>
                          <p className="text-gray-500 text-xs" data-id="element-5862" data-mp="37xdg1l4g8g7g">Fecha</p>
                        </div>
                      </div>
                      <div className="mt-12 text-center" data-id="element-5863" data-mp="2y5heg035m7yh">
                        <p className="text-xs text-gray-500" data-id="element-5864" data-mp="2y3wji9cxgn03">
                          Gracias por su confianza
                        </p>
                      </div>
                    </div>
                  </div>}
              </div>}
            {/* Items Section */}
            {activeSection === 'items' && <div className="space-y-6" data-id="element-5865" data-mp="2a9mu0har66rq">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5866" data-mp="2f6d9p3inb0cm">
                  <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-5867" data-mp="8fxey199qst6">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5868" data-mp="dfs33x1nt4aj">
                      <ShoppingCartIcon size={18} className="mr-2 text-gray-500" data-id="element-5869" data-mp="1xx1blma1w9v1" />
                      Quote Items
                    </h2>
                    <div className="flex items-center space-x-2" data-id="element-5870" data-mp="1t014d81gt12c">
                      <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-5871" data-mp="27nm3yrz4si5i">
                        <FilterIcon size={16} data-id="element-5872" data-mp="22wxdnfz6tr7y" />
                      </button>
                      <button className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center hover:bg-blue-700" data-id="element-5873" data-mp="22ut006bhlduh">
                        <PlusIcon size={14} className="mr-1" data-id="element-5874" data-mp="2bph8s6g9tdo1" />
                        Add Item
                      </button>
                    </div>
                  </div>
                  <div className="overflow-x-auto" data-id="element-5875" data-mp="2ln5bpjo15rha">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-5876" data-mp="2logdjdxx0p5r">
                      <thead className="bg-gray-50" data-id="element-5877" data-mp="w7ffaogg4cpe">
                        <tr data-id="element-5878" data-mp="wa1wlft526kt">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5879" data-mp="r9nlfow8qgik">
                            Item
                          </th>
                          <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5880" data-mp="1kybjtqyansme">
                            Qty
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5881" data-mp="1uxkaa9tyap40">
                            Unit Price
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5882" data-mp="23x7awteuvqw0">
                            Discount
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5883" data-mp="2dns9iguj4vex">
                            Total
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5884" data-mp="2nkwyspjo96zy">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-5885" data-mp="71mkcdsj2h3x">
                        {quote.items.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-5886" data-mp="22055yt52qsh">
                            <td className="px-6 py-4" data-id="element-5887" data-mp="3t8b0debgwxbw">
                              <div className="text-sm font-medium text-gray-900" data-id="element-5888" data-mp="updy7ltpv27b">
                                {item.name}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-5889" data-mp="ps3wp7t1z034">
                                {item.description}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5890" data-mp="fxvjdrclfdpj">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5891" data-mp="18n2d8d13rf4g">
                              {formatCurrency(item.unitPrice)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5892" data-mp="y709i2tweya9">
                              {item.discount > 0 ? <span className="text-green-600" data-id="element-5893" data-mp="o7j4zoqduqfv">
                                  {item.discount}%
                                </span> : '-'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5894" data-mp="1bzg5wksany27">
                              {formatCurrency(item.total)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-5895" data-mp="176dikue41kug">
                              <div className="flex items-center justify-end space-x-2" data-id="element-5896" data-mp="1uw7vtd2cdbf8">
                                <button className="text-blue-600 hover:text-blue-900" onClick={() => handleViewItem(item)} data-id="element-5897" data-mp="1zmo8uw292v12">
                                  <EyeIcon size={16} data-id="element-5898" data-mp="3kcju5fi56gn4" />
                                </button>
                                <button className="text-gray-500 hover:text-gray-700" data-id="element-5899" data-mp="3feie73g0ixfv">
                                  <PencilIcon size={16} data-id="element-5900" data-mp="3u2n0ehe9xr3e" />
                                </button>
                                <button className="text-red-500 hover:text-red-700" data-id="element-5901" data-mp="3p41xubbjuvbs">
                                  <TrashIcon size={16} data-id="element-5902" data-mp="3p662wwl6q0dn" />
                                </button>
                              </div>
                            </td>
                          </tr>)}
                      </tbody>
                      <tfoot className="bg-gray-50" data-id="element-5903" data-mp="3aff8rhw4ep7d">
                        <tr data-id="element-5904" data-mp="3ag8jsv2440vb">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5905" data-mp="36dbxoudd5mmm">
                            Subtotal
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5906" data-mp="pqrhg8tmdida">
                            {formatCurrency(quote.amount)}
                          </td>
                          <td data-id="element-5907" data-mp="3ehbnj3h0e0el"></td>
                        </tr>
                        {quote.discount > 0 && <tr data-id="element-5908" data-mp="3jf3ark6pkycg">
                            <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5909" data-mp="3jihg91ao5no4">
                              Discount ({quote.discount}%)
                            </td>
                            <td className="px-6 py-3 text-right text-sm font-medium text-green-600" data-id="element-5910" data-mp="2vr298v7y6i6j">
                              -
                              {formatCurrency(quote.amount * (quote.discount / 100))}
                            </td>
                            <td data-id="element-5911" data-mp="34qysghbkiou7"></td>
                          </tr>}
                        <tr data-id="element-5912" data-mp="39j0aykzbxbso">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5913" data-mp="39ja3ogbrdx22">
                            Tax ({quote.tax}%)
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5914" data-mp="2h14etxjfcw8w">
                            {formatCurrency(quote.taxAmount)}
                          </td>
                          <td data-id="element-5915" data-mp="24jbt8vm4n04o"></td>
                        </tr>
                        <tr data-id="element-5916" data-mp="24hr1fdr75vai">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5917" data-mp="20hgrjq0aakqd">
                            Total
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-blue-600" data-id="element-5918" data-mp="1qjso8bom44wl">
                            {formatCurrency(quote.total)}
                          </td>
                          <td data-id="element-5919" data-mp="1lr9a9dm0j7r9"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                {/* Competitive Analysis */}
                {quote.competitors && quote.competitors.length > 0 && <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5920" data-mp="17rzv8h9jmjov">
                    <div className="px-6 py-4 border-b border-gray-200" data-id="element-5921" data-mp="12uq8j9djgm4q">
                      <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5922" data-mp="2qqo227hghw38">
                        <BarChart2Icon size={18} className="mr-2 text-gray-500" data-id="element-5923" data-mp="2vq910hwmm4fy" />
                        Competitive Analysis
                      </h2>
                    </div>
                    <div className="p-6" data-id="element-5924" data-mp="2mpaxe0q3nyxw">
                      <div className="space-y-4" data-id="element-5925" data-mp="2mnzqvt59sd33">
                        <div className="flex items-center justify-between bg-blue-50 p-4 rounded-lg" data-id="element-5926" data-mp="280era97lsvzx">
                          <div className="flex items-center" data-id="element-5927" data-mp="2cr4wnmg14yum">
                            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-5928" data-mp="2csfwxca9nogz">
                              <CheckCircleIcon size={20} className="text-blue-600" data-id="element-5929" data-mp="1yxx3hqcavvat" />
                            </div>
                            <div data-id="element-5930" data-mp="1p1u1qlld1yoe">
                              <div className="font-medium" data-id="element-5931" data-mp="1p2lp594t0q3l">Our Quote</div>
                              <div className="text-sm text-gray-500" data-id="element-5932" data-mp="1u16lgxgxqpmr">
                                Valley Irrigation
                              </div>
                            </div>
                          </div>
                          <div className="text-xl font-bold text-blue-600" data-id="element-5933" data-mp="15gtssa4q7d0b">
                            {formatCurrency(quote.total)}
                          </div>
                        </div>
                        {quote.competitors.map((competitor, index) => <div key={index} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg" data-id="element-5934" data-mp="1fg17p1r3zfpj" data-mpi={index}>
                            <div className="flex items-center" data-id="element-5935" data-mp="1oemk0f5zlyhv">
                              <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-4" data-id="element-5936" data-mp="1oect8pd4bnb4">
                                <BuildingIcon size={20} className="text-gray-600" data-id="element-5937" data-mp="235dbfm3o2vkg" />
                              </div>
                              <div data-id="element-5938" data-mp="2c3xoo7qgkd1a">
                                <div className="font-medium" data-id="element-5939" data-mp="2c50f6ejvcdgo">
                                  {competitor.name}
                                </div>
                                <div className="flex space-x-2 mt-1" data-id="element-5940" data-mp="30fp8rwf5njlw">
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800" data-id="element-5941" data-mp="30fyyrk079qrl">
                                    {competitor.strengths}
                                  </span>
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800" data-id="element-5942" data-mp="3abihf4pr6sye">
                                    {competitor.weaknesses}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="text-lg font-medium text-gray-900" data-id="element-5943" data-mp="3t4cutu7qad0i">
                              {formatCurrency(competitor.price)}
                            </div>
                          </div>)}
                      </div>
                      <div className="mt-6" data-id="element-5944" data-mp="6y7mlhkq54su">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-5945" data-mp="6us4s6zo1hnq">
                          Price Comparison
                        </div>
                        <div className="h-4 bg-gray-200 rounded-full overflow-hidden" data-id="element-5946" data-mp="lkwil9frozuh">
                          <div className="h-full bg-blue-600" style={{
                      width: '65%'
                    }} data-id="element-5947" data-mp="plq641pascmu"></div>
                        </div>
                        <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-5948" data-mp="gks39mqlib5u">
                          <span data-id="element-5949" data-mp="gmldfc0f3dil">Our price is competitive</span>
                          <span data-id="element-5950" data-mp="1v2pms1bgeoo">35% lower than highest competitor</span>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>}
            {/* Customer Info Section */}
            {activeSection === 'customer' && <div className="space-y-6" data-id="element-5951" data-mp="3tz545xjvgqd5">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5952" data-mp="3tzwscnb53lte">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-5953" data-mp="3f35z6vs276c8">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5954" data-mp="3k05vwg30qwqo">
                      <UserIcon size={18} className="mr-2 text-gray-500" data-id="element-5955" data-mp="30xxctgx3dyfu" />
                      Customer Information
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-5956" data-mp="2r72fnhib5efm">
                    <div className="flex flex-col md:flex-row md:items-start" data-id="element-5957" data-mp="2r83yi85kf57w">
                      <div className="md:w-1/3 mb-6 md:mb-0 md:pr-6" data-id="element-5958" data-mp="2m8r3v18gctur">
                        <div className="flex items-center" data-id="element-5959" data-mp="3jvq3nkufyhwv">
                          <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-5960" data-mp="3jv80s5d9x5fz">
                            <UserIcon size={28} className="text-blue-600" data-id="element-5961" data-mp="3exexpl79orjx" />
                          </div>
                          <div className="ml-4" data-id="element-5962" data-mp="39zn32jf8mrc1">
                            <h3 className="text-xl font-medium text-gray-900" data-id="element-5963" data-mp="34z8souq5z5au">
                              {quote.customer}
                            </h3>
                            <p className="text-gray-500" data-id="element-5964" data-mp="1yg0wl5bhuyqt">{quote.company}</p>
                          </div>
                        </div>
                        <div className="mt-6 space-y-4" data-id="element-5965" data-mp="9219yyauz7nj">
                          <div data-id="element-5966" data-mp="8zf0gt4eqi2o">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5967" data-mp="dztc0l57wa5g">
                              Contact Information
                            </div>
                            <div className="space-y-2" data-id="element-5968" data-mp="ixmf35b84o1i">
                              <div className="flex items-center text-gray-700" data-id="element-5969" data-mp="nqxp1fbc1kxn">
                                <MailIcon size={16} className="mr-2 text-gray-500" data-id="element-5970" data-mp="sq0j64pry6qu" />
                                <a href={`mailto:${quote.customerEmail}`} className="text-blue-600 hover:text-blue-800" data-id="element-5971" data-mp="wqb0gdj0ojl0">
                                  {quote.customerEmail}
                                </a>
                              </div>
                              <div className="flex items-center text-gray-700" data-id="element-5972" data-mp="16o8nwyt1ycck">
                                <PhoneIcon size={16} className="mr-2 text-gray-500" data-id="element-5973" data-mp="33ilk156sd3dt" />
                                <a href={`tel:${quote.customerPhone}`} className="text-blue-600 hover:text-blue-800" data-id="element-5974" data-mp="38hg1o3t0olwc">
                                  {quote.customerPhone}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-5975" data-mp="1brhlxsdynxpn">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5976" data-mp="1bqolf95li4fy">
                              Location
                            </div>
                            <div className="flex items-start text-gray-700" data-id="element-5977" data-mp="k2o6vxzaoqhn">
                              <MapPinIcon size={16} className="mr-2 mt-1 text-gray-500 flex-shrink-0" data-id="element-5978" data-mp="f31utrv7dgaf" />
                              <span data-id="element-5979" data-mp="sugbhs1n15eb">{quote.companyAddress}</span>
                            </div>
                          </div>
                          <div data-id="element-5980" data-mp="o2exa0kwt4ln">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5981" data-mp="o1dj3n8lk1zp">
                              Region
                            </div>
                            <div className="flex items-center text-gray-700" data-id="element-5982" data-mp="3sgd8kzu6vijn">
                              <GlobeIcon size={16} className="mr-2 text-gray-500" data-id="element-5983" data-mp="3icybyy7vpu8n" />
                              <span data-id="element-5984" data-mp="3n3y65vpm5y7g">
                                {quote.region}, {quote.country}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="md:w-2/3 md:border-l md:border-gray-200 md:pl-6" data-id="element-5985" data-mp="3deodoequydit">
                        <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-5986" data-mp="4z4obqtb5f91">
                          Customer Activity
                        </h3>
                        <div className="space-y-6" data-id="element-5987" data-mp="3r61rrd5zyj6g">
                          <div data-id="element-5988" data-mp="3r5jovxotx6pk">
                            <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-5989" data-mp="3w4w90aobfzog">
                              Recent Quotes
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4" data-id="element-5990" data-mp="2fp38o25gam1n">
                              <div className="text-center text-gray-500 py-4" data-id="element-5991" data-mp="2kqshdb57anmk">
                                <ClipboardIcon size={24} className="mx-auto mb-2 text-gray-400" data-id="element-5992" data-mp="r7iecwsyna43" />
                                <p data-id="element-5993" data-mp="m7dyn8zvmjex">
                                  No previous quotes found for this customer
                                </p>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-5994" data-mp="chuem00fgjih">
                            <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-5995" data-mp="7j1c12moicx3">
                              Engagement
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4" data-id="element-5996" data-mp="3fuyd9x8ljgl">
                              <div className="grid grid-cols-2 gap-4" data-id="element-5997" data-mp="3uos8xb8p79ss">
                                <div data-id="element-5998" data-mp="3pow63fbqloet">
                                  <div className="text-xs text-gray-500" data-id="element-5999" data-mp="3ppxracmgvra9">
                                    Last Contact
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-6000" data-mp="1nxj4az52fwmz">
                                    2 days ago
                                  </div>
                                </div>
                                <div data-id="element-6001" data-mp="20flryn0onqd9">
                                  <div className="text-xs text-gray-500" data-id="element-6002" data-mp="20ekd07gjqjq9">
                                    Response Time
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-6003" data-mp="2a67zdty8xakv">
                                    4 hours avg.
                                  </div>
                                </div>
                                <div data-id="element-6004" data-mp="1hgrdzg91mty5">
                                  <div className="text-xs text-gray-500" data-id="element-6005" data-mp="1hhsptmxvvkgx">
                                    Interactions
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-6006" data-mp="1rfq9ry8pmv3q">
                                    5 total
                                  </div>
                                </div>
                                <div data-id="element-6007" data-mp="32u3uiu862ufj">
                                  <div className="text-xs text-gray-500" data-id="element-6008" data-mp="32t11ograahwz">
                                    Status
                                  </div>
                                  <div className="text-sm font-medium text-blue-600" data-id="element-6009" data-mp="3izlam59y32fu">
                                    Active
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-6010" data-mp="aiytz8b5tzpm">
                            <div className="flex justify-between items-center mb-2" data-id="element-6011" data-mp="ai6wfry05rwp">
                              <div className="text-sm font-medium text-gray-500" data-id="element-6012" data-mp="6gv59hzhcyme">
                                Notes
                              </div>
                              <button className="text-blue-600 text-sm hover:text-blue-800" onClick={() => setShowNotes(true)} data-id="element-6013" data-mp="kfbjrv3l3tf3">
                                Add Note
                              </button>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4 space-y-3" data-id="element-6014" data-mp="2hazn6b9z2ac7">
                              {quote.notes.length > 0 ? quote.notes.map(note => <div key={note.id} className={`p-3 rounded-md ${note.isPrivate ? 'bg-blue-50 border border-blue-100' : 'bg-white border border-gray-200'}`} data-id="element-6015" data-mp="wsp2ge8twc8e">
                                    <div className="flex justify-between items-start mb-1" data-id="element-6016" data-mp="n1cbdouutq3f">
                                      <div className="font-medium text-gray-900" data-id="element-6017" data-mp="s05h2v3wgct1">
                                        {note.author}
                                      </div>
                                      <div className="text-xs text-gray-500" data-id="element-6018" data-mp="j11wtnszxrcy">
                                        {note.date}
                                      </div>
                                    </div>
                                    <p className="text-sm text-gray-700" data-id="element-6019" data-mp="93dzqr7x47rm">
                                      {note.text}
                                    </p>
                                    {note.isPrivate && <div className="mt-2 text-xs flex items-center text-blue-600" data-id="element-6020" data-mp="23gvp8jrvvepa">
                                        <LockIcon size={12} className="mr-1" data-id="element-6021" data-mp="34psldebls683" />
                                        Private note
                                      </div>}
                                  </div>) : <div className="text-center text-gray-500 py-4" data-id="element-6022" data-mp="3dpxtxrsj9anu">
                                  <MessageSquareIcon size={24} className="mx-auto mb-2 text-gray-400" data-id="element-6023" data-mp="3dnusmblxjv3t" />
                                  <p data-id="element-6024" data-mp="3nfhdkzo2l8jr">No notes available for this customer</p>
                                </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Terms & Conditions Section */}
            {activeSection === 'terms' && <div className="space-y-6" data-id="element-6025" data-mp="57i355jxf5kv">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6026" data-mp="2237l7luvwwel">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6027" data-mp="272ahagsvzsaf">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6028" data-mp="1zi85tzwd9s9k">
                      <ClipboardIcon size={18} className="mr-2 text-gray-500" data-id="element-6029" data-mp="1ur9oqy3k0q59" />
                      Terms & Conditions
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6030" data-mp="1ppu1r0htg9k8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-6031" data-mp="1ktc0ialp2tcn">
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-6032" data-mp="2igke7jfgey43">
                        <div className="flex items-center mb-3" data-id="element-6033" data-mp="2ifsup6z4squ6">
                          <DollarSignIcon size={18} className="text-blue-600 mr-2" data-id="element-6034" data-mp="2diiyn8h8lgxd" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-6035" data-mp="28hv6gjh9uu1k">
                            Payment Terms
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-6036" data-mp="x39by4gzo5is">{quote.paymentTerms}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-6037" data-mp="x14yovx79u5u">
                          <p data-id="element-6038" data-mp="t0uv1pwvrfu5">
                            Payment is due according to the terms specified.
                            Late payments may be subject to additional fees.
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-6039" data-mp="kl5a0hkpr3wf">
                        <div className="flex items-center mb-3" data-id="element-6040" data-mp="kmztdrgc6nye">
                          <TruckIcon size={18} className="text-blue-600 mr-2" data-id="element-6041" data-mp="pi5eio1wzylf" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-6042" data-mp="braem19e8rtz">
                            Delivery Terms
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-6043" data-mp="1untrch2i0ry">{quote.deliveryTerms}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-6044" data-mp="6t8kmlafj83q">
                          <p data-id="element-6045" data-mp="6tia87rkbd8w">
                            Shipping and handling costs are calculated based on
                            delivery location and product specifications.
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-6046" data-mp="3ad6as6yu245c">
                        <div className="flex items-center mb-3" data-id="element-6047" data-mp="35dbko5mvtilc">
                          <ClockIcon size={18} className="text-blue-600 mr-2" data-id="element-6048" data-mp="35f4uftsskixk" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-6049" data-mp="3jeea8sd35b10">
                            Validity Period
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-6050" data-mp="3t9z6e9vh3h2u">{quote.validityPeriod}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-6051" data-mp="3ocfsjb2ot6bf">
                          <p data-id="element-6052" data-mp="3oa3c52ckv40h">
                            This quote is valid for the specified period from
                            the date of issue. After this period, prices may be
                            subject to change.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-gray-200 pt-6" data-id="element-6053" data-mp="ay2owsi10d0f">
                      <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6054" data-mp="uze05vwhfeea">
                        Full Terms & Conditions
                      </h3>
                      <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-6055" data-mp="yz6dsn0qgaqi">
                        <p className="text-gray-700 whitespace-pre-line" data-id="element-6056" data-mp="13sr0vk0sfkax">
                          {quote.terms}
                          {/* Additional terms text for demonstration */}
                          {`\n\n1. ACCEPTANCE: This quotation constitutes an offer by Valley Irrigation ("Seller") to the customer identified on the face of this document ("Buyer") for the sale of the products described herein. Acceptance of this offer is expressly limited to the terms and conditions contained herein.
2. PRICES: Prices quoted are valid for the period indicated. Prices do not include any federal, state, or local taxes unless specifically stated. Any such taxes will be added to the invoice and paid by Buyer unless Buyer provides Seller with a valid tax exemption certificate.
3. PAYMENT: Payment terms are as specified in this quotation. Buyer agrees to pay all costs of collection, including reasonable attorney's fees, incurred by Seller in collecting any amounts due from Buyer.
4. DELIVERY: Delivery dates are approximate and based upon prompt receipt of all necessary information from Buyer. Seller shall not be liable for delays in delivery or performance due to causes beyond its reasonable control.
5. WARRANTY: Seller warrants that the products sold hereunder will be free from defects in material and workmanship for the period specified in Seller's standard warranty for such products. THIS WARRANTY IS EXCLUSIVE AND IN LIEU OF ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
6. LIMITATION OF LIABILITY: Seller's liability shall be limited to the cost of repairing or replacing, at Seller's option, any defective product. IN NO EVENT SHALL SELLER BE LIABLE FOR ANY SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES.
7. ENTIRE AGREEMENT: This quotation, together with any documents referenced herein, constitutes the entire agreement between Buyer and Seller with respect to the subject matter hereof and supersedes all prior negotiations and understandings.`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Attachments Section */}
            {activeSection === 'attachments' && <div className="space-y-6" data-id="element-6057" data-mp="34mvdiv9f1fn1">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6058" data-mp="34ltx0b9ms0xx">
                  <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6059" data-mp="2qqhsxd9l4y4c">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6060" data-mp="1f8zy539zf8ty">
                      <Paperclip size={18} className="mr-2 text-gray-500" data-id="element-6061" data-mp="1fbcpg71mqvjo" />
                      Attachments
                    </h2>
                    <button className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center hover:bg-blue-700" data-id="element-6062" data-mp="1bqj8ix7z4xff">
                      <PlusIcon size={14} className="mr-1" data-id="element-6063" data-mp="16r6d3o31ei18" />
                      Add File
                    </button>
                  </div>
                  <div className="p-6" data-id="element-6064" data-mp="1gq5ohef6srrx">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6065" data-mp="1gr6zjiw7de9n">
                      {quote.attachments.map((attachment, index) => <div key={index} className="flex items-center p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors" data-id="element-6066" data-mp="t12tz5zgf4g0" data-mpi={index}>
                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-4" data-id="element-6067" data-mp="12qme0eywl4cg">
                            {getFileIcon(attachment.type)}
                          </div>
                          <div className="flex-1 min-w-0" data-id="element-6068" data-mp="a91q1p7tonzq">
                            <div className="text-sm font-medium text-gray-900 truncate" data-id="element-6069" data-mp="5b05t0ynuimo">
                              {attachment.name}
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-6070" data-mp="3fyw72dejugah">
                              {attachment.size}
                            </div>
                          </div>
                          <div className="flex space-x-2" data-id="element-6071" data-mp="3pufyonm2ystf">
                            <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-6072" data-mp="3twkqdgsyxfdf">
                              <EyeIcon size={16} data-id="element-6073" data-mp="2qjgvconittw" />
                            </button>
                            <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-6074" data-mp="2op1edw5ftx7">
                              <DownloadIcon size={16} data-id="element-6075" data-mp="7nji9aak38eo" />
                            </button>
                            <button className="text-red-500 hover:text-red-700 p-1" data-id="element-6076" data-mp="ch4il8zmgeh1">
                              <TrashIcon size={16} data-id="element-6077" data-mp="hewdmbvkcgpg" />
                            </button>
                          </div>
                        </div>)}
                    </div>
                    <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-6078" data-mp="qh5m6w79u007">
                      <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6079" data-mp="2axwpgzb0vh0n">
                        Upload New Files
                      </h3>
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-6080" data-mp="25xieb8e4jqye">
                        <div className="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3" data-id="element-6081" data-mp="21xqdxiyvwr44">
                          <Paperclip size={24} className="text-gray-500" data-id="element-6082" data-mp="1x0q8na9uzse2" />
                        </div>
                        <p className="text-gray-700 mb-2" data-id="element-6083" data-mp="2pn16id62zf76">
                          Drag and drop files here, or click to browse
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-6084" data-mp="2kv19otlb52et">
                          Supported formats: PDF, DOC, XLS, JPG, PNG (Max 10MB)
                        </p>
                        <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700" data-id="element-6085" data-mp="3dcvi6renyxpu">
                          Browse Files
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Approval Workflow Section */}
            {activeSection === 'approvals' && <div className="space-y-6" data-id="element-6086" data-mp="1ubif8eq2dap2">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6087" data-mp="1u9p86ybjgogj">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6088" data-mp="1yef3om2ac10x">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6089" data-mp="23cqasp173xfg">
                      <CheckSquare size={18} className="mr-2 text-gray-500" data-id="element-6090" data-mp="28a9rdvld8mak" />
                      Approval Workflow
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6091" data-mp="2d44aawt5cx8l">
                    <div className="max-w-3xl mx-auto" data-id="element-6092" data-mp="2i14hjb1qg61a">
                      <div className="relative" data-id="element-6093" data-mp="2i2nuoss3e0yu">
                        <div className="absolute left-8 top-0 h-full w-0.5 bg-gray-200" data-id="element-6094" data-mp="2m3hizn9g5hs9"></div>
                        {/* Level 1 */}
                        <div className="relative z-10 flex items-start mb-8" data-id="element-6095" data-mp="2qzgervx3u22p">
                          <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6096" data-mp="ffqznvp1lmjx">
                            <div className="w-8 h-8 rounded-full bg-green-100 border-4 border-white flex items-center justify-center" data-id="element-6097" data-mp="adji8qlg1ea7">
                              <CheckIcon size={16} className="text-green-600" data-id="element-6098" data-mp="1eejbj5yzixi" />
                            </div>
                          </div>
                          <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6099" data-mp="y3m60uibry30">
                            <div className="flex justify-between items-start" data-id="element-6100" data-mp="u3lr78rbdkvf">
                              <div data-id="element-6101" data-mp="pbbwlff97wmt">
                                <h3 className="text-lg font-medium text-gray-900" data-id="element-6102" data-mp="pa92yzqjrg37">
                                  {quote.approvalStatus.level1.name}
                                </h3>
                                <p className="text-gray-500" data-id="element-6103" data-mp="1htzc8fbhejgi">
                                  First level approval required for all quotes
                                </p>
                              </div>
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-6104" data-mp="1w09lqx0qo4az">
                                Approved
                              </span>
                            </div>
                            <div className="mt-4 text-sm text-gray-700" data-id="element-6105" data-mp="1r6exrhe3p363">
                              <p data-id="element-6106" data-mp="1d75s3bnitrgd">
                                Approved by {quote.approvalStatus.level1.by} •{' '}
                                {quote.approvalStatus.level1.date}
                              </p>
                              <p className="mt-1 text-gray-500" data-id="element-6107" data-mp="1482885gj580t">
                                Comments: Pricing and terms look good. Approved
                                for next level review.
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* Level 2 */}
                        {quote.approvalStatus.level2.status !== 'not_required' && <div className="relative z-10 flex items-start mb-8" data-id="element-6108" data-mp="qztcq90z2h2i">
                            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6109" data-mp="myzlp6s8gm5e">
                              <div className={`w-8 h-8 rounded-full ${quote.approvalStatus.level2.status === 'approved' ? 'bg-green-100' : 'bg-amber-100'} border-4 border-white flex items-center justify-center`} data-id="element-6110" data-mp="10puy2t1xxldq">
                                {quote.approvalStatus.level2.status === 'approved' ? <CheckIcon size={16} className="text-green-600" data-id="element-6111" data-mp="15opgvuzwr9xu" /> : <ClockIcon size={16} className="text-amber-600" data-id="element-6112" data-mp="15nwj3jixfuru" />}
                              </div>
                            </div>
                            <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6113" data-mp="1eocfk91961n7">
                              <div className="flex justify-between items-start" data-id="element-6114" data-mp="3lgddfpb0f0g4">
                                <div data-id="element-6115" data-mp="3gh0pt2cbdpch">
                                  <h3 className="text-lg font-medium text-gray-900" data-id="element-6116" data-mp="3gi21n915mfv9">
                                    {quote.approvalStatus.level2.name}
                                  </h3>
                                  <p className="text-gray-500" data-id="element-6117" data-mp="3muwkj3jyofg1">
                                    Required for quotes over $25,000
                                  </p>
                                </div>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${quote.approvalStatus.level2.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-6118" data-mp="ohptdb4fi7f">
                                  {quote.approvalStatus.level2.status === 'approved' ? 'Approved' : 'Pending'}
                                </span>
                              </div>
                              <div className="mt-4 text-sm text-gray-700" data-id="element-6119" data-mp="2ggf11z1thtg3">
                                {quote.approvalStatus.level2.status === 'approved' ? <>
                                    <p data-id="element-6120" data-mp="2ldnnwcxwulno">
                                      Approved by{' '}
                                      {quote.approvalStatus.level2.by} •{' '}
                                      {quote.approvalStatus.level2.date}
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6121" data-mp="23w8bfyrv3as6">
                                      Comments: Financial terms verified and
                                      approved.
                                    </p>
                                  </> : <>
                                    <p data-id="element-6122" data-mp="1q5dbxd396619">Awaiting approval</p>
                                    <p className="mt-1 text-gray-500" data-id="element-6123" data-mp="1l7bhjw0dmkah">
                                      This quote is currently under review by
                                      the finance department.
                                    </p>
                                    <button className="mt-3 bg-amber-100 text-amber-800 px-3 py-1 rounded-md text-sm flex items-center" data-id="element-6124" data-mp="1b7ue7l8lkiho">
                                      <RefreshCwIcon size={14} className="mr-1" data-id="element-6125" data-mp="179wngdz6hoc6" />
                                      Check Status
                                    </button>
                                  </>}
                              </div>
                            </div>
                          </div>}
                        {/* Level 3 */}
                        {quote.approvalStatus.level3.status !== 'not_required' && <div className="relative z-10 flex items-start" data-id="element-6126" data-mp="1gaefqx9itgcs">
                            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6127" data-mp="1gb7no1k7ubwi">
                              <div className={`w-8 h-8 rounded-full ${quote.approvalStatus.level3.status === 'approved' ? 'bg-green-100' : quote.approvalStatus.level3.status === 'pending' ? 'bg-amber-100' : 'bg-blue-100'} border-4 border-white flex items-center justify-center`} data-id="element-6128" data-mp="1ke417duwfhtl">
                                {quote.approvalStatus.level3.status === 'approved' ? <CheckIcon size={16} className="text-green-600" data-id="element-6129" data-mp="23zqqi1khxwh7" /> : quote.approvalStatus.level3.status === 'pending' ? <ClockIcon size={16} className="text-amber-600" data-id="element-6130" data-mp="2deajtwo4xzcc" /> : <InfoIcon size={16} className="text-blue-600" data-id="element-6131" data-mp="2dczjy7xt9bqi" />}
                              </div>
                            </div>
                            <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6132" data-mp="2n55794d4b4zd">
                              <div className="flex justify-between items-start" data-id="element-6133" data-mp="2i6k7f61s2nbg">
                                <div data-id="element-6134" data-mp="1ufeuayn8294u">
                                  <h3 className="text-lg font-medium text-gray-900" data-id="element-6135" data-mp="1uggcdn2nnvw2">
                                    {quote.approvalStatus.level3.name}
                                  </h3>
                                  <p className="text-gray-500" data-id="element-6136" data-mp="24fp4eadyn0fs">
                                    Required for quotes over $100,000
                                  </p>
                                </div>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${quote.approvalStatus.level3.status === 'approved' ? 'bg-green-100 text-green-800' : quote.approvalStatus.level3.status === 'pending' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-6137" data-mp="3frg90icgnbxr">
                                  {quote.approvalStatus.level3.status === 'approved' ? 'Approved' : quote.approvalStatus.level3.status === 'pending' ? 'Pending' : 'Not Required'}
                                </span>
                              </div>
                              <div className="mt-4 text-sm text-gray-700" data-id="element-6138" data-mp="1ruqiex2l2g0j">
                                {quote.approvalStatus.level3.status === 'approved' ? <>
                                    <p data-id="element-6139" data-mp="20vopxpc8d5nv">
                                      Approved by{' '}
                                      {quote.approvalStatus.level3.by} •{' '}
                                      {quote.approvalStatus.level3.date}
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6140" data-mp="bha1z791dmtf">
                                      Comments: Executive approval granted.
                                    </p>
                                  </> : quote.approvalStatus.level3.status === 'pending' ? <>
                                    <p data-id="element-6141" data-mp="3valrm02kxaof">Awaiting approval</p>
                                    <p className="mt-1 text-gray-500" data-id="element-6142" data-mp="3qe3qrbaddwhd">
                                      This quote is awaiting executive review.
                                    </p>
                                  </> : <>
                                    <p data-id="element-6143" data-mp="muitom19r0da">
                                      This level of approval is not required for
                                      this quote
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6144" data-mp="d0a5ubn6nvlg">
                                      Executive approval is only needed for
                                      quotes exceeding $100,000.
                                    </p>
                                  </>}
                              </div>
                            </div>
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Analytics Section */}
            {activeSection === 'analytics' && <div className="space-y-6" data-id="element-6145" data-mp="225to1dpamyg7">
                {/* Score Card */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6146" data-mp="1xch7lqurpxyj">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6147" data-mp="2b3m0ma3mrrzw">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6148" data-mp="273v55t35snp1">
                      <StarIcon size={18} className="mr-2 text-gray-500" data-id="element-6149" data-mp="2l2ur2szaeohi" />
                      Quote Score
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6150" data-mp="2g4t8e95rwr6k">
                    <div className="flex flex-col md:flex-row items-center" data-id="element-6151" data-mp="qott0abka5ih">
                      <div className="relative w-40 h-40 mb-6 md:mb-0 md:mr-8" data-id="element-6152" data-mp="qqwsrm2ind0e">
                        {/* Circle background */}
                        <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-6153" data-mp="2xcsuo9auxy9e">
                          <circle cx="50" cy="50" r="45" fill="transparent" stroke="#e5e7eb" strokeWidth="10" data-id="element-6154" data-mp="32cffp4wxgisr" />
                          <circle cx="50" cy="50" r="45" fill="transparent" stroke={quote.score >= 80 ? '#10b981' : quote.score >= 60 ? '#3b82f6' : quote.score >= 40 ? '#f59e0b' : '#ef4444'} strokeWidth="10" strokeDasharray="282.7" strokeDashoffset={282.7 - 282.7 * quote.score / 100} transform="rotate(-90 50 50)" data-id="element-6155" data-mp="2nnsuimkmcwtm" />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-6156" data-mp="2jnim739ctubl">
                          <span className={`text-4xl font-bold ${getScoreColor(quote.score)}`} data-id="element-6157" data-mp="24q859edxzw8h">
                            {quote.score}
                          </span>
                          <span className="text-sm text-gray-500" data-id="element-6158" data-mp="2yd61y8vhk75">
                            out of 100
                          </span>
                        </div>
                      </div>
                      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6159" data-mp="6fhm6tuueoa3">
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6160" data-mp="1flhsti8guu0">
                          <div className="flex items-center justify-between mb-2" data-id="element-6161" data-mp="3sm63dxpirajn">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6162" data-mp="3okuczpytmlae">
                              Probability of Closing
                            </div>
                            <div className="text-green-600 font-medium" data-id="element-6163" data-mp="p4xptq1tqwuq">
                              Very High
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6164" data-mp="feupt5wacimw">
                            <div className="bg-green-600 h-2.5 rounded-full" style={{
                          width: '85%'
                        }} data-id="element-6165" data-mp="bf41r9y58gm2"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6166" data-mp="134ozjelb5r2x">
                          <div className="flex items-center justify-between mb-2" data-id="element-6167" data-mp="2lt9z5bko1q4b">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6168" data-mp="2qqjlujgo7nog">
                              Margin
                            </div>
                            <div className="text-blue-600 font-medium" data-id="element-6169" data-mp="2uv142e7dtsx4">
                              Good
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6170" data-mp="34qb8f8l96ce2">
                            <div className="bg-blue-600 h-2.5 rounded-full" style={{
                          width: '70%'
                        }} data-id="element-6171" data-mp="39pe4w4n63aaf"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6172" data-mp="3ih7o5yu2yz3p">
                          <div className="flex items-center justify-between mb-2" data-id="element-6173" data-mp="3niwytdde5ar9">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6174" data-mp="3sfvtbx0yvjpz">
                              Customer Relationship
                            </div>
                            <div className="text-amber-600 font-medium" data-id="element-6175" data-mp="39uv89wg1qvfm">
                              Medium
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6176" data-mp="3oizvndq1nv4q">
                            <div className="bg-amber-500 h-2.5 rounded-full" style={{
                          width: '50%'
                        }} data-id="element-6177" data-mp="3jl6ooigx2x3e"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6178" data-mp="2qy3shwzpqygb">
                          <div className="flex items-center justify-between mb-2" data-id="element-6179" data-mp="35ul48pbtef3e">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6180" data-mp="30tdr0aqwknpc">
                              Competitive Position
                            </div>
                            <div className="text-green-600 font-medium" data-id="element-6181" data-mp="g4hgyt5llhc5">
                              Strong
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6182" data-mp="smk3gdphb50u">
                            <div className="bg-green-600 h-2.5 rounded-full" style={{
                          width: '80%'
                        }} data-id="element-6183" data-mp="skh4v5a9g3ki"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Comparison with Similar Quotes */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6184" data-mp="1bbqfxizoj0e7">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6185" data-mp="xl558hkdpwre">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6186" data-mp="11mgn20x0hdp1">
                      <BarChart2Icon size={18} className="mr-2 text-gray-500" data-id="element-6187" data-mp="1pcaw07e7mi40" />
                      Comparison with Similar Quotes
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6188" data-mp="23zjc9mmdldmu">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6189" data-mp="23yi2rml0cz78">
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6190" data-mp="1zxeov5mitd8n">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6191" data-mp="1uyl8n5fun84s">
                          Average Close Rate
                        </div>
                        <div className="flex items-end" data-id="element-6192" data-mp="1pzie4exhwkb2">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6193" data-mp="1l0xbk8urtojg">
                            68%
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6194" data-mp="1g8ns9bo5vmq5">
                            <TrendingUpIcon size={14} className="mr-1" data-id="element-6195" data-mp="1c8vcadwfuear" />
                            +24%
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6196" data-mp="12aflyd58j92b">
                          This quote has a higher close rate than average
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6197" data-mp="n7xnt125lwo3">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6198" data-mp="s5pqmq4c7372">
                          Average Time to Close
                        </div>
                        <div className="flex items-end" data-id="element-6199" data-mp="x394hox4hdyh">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6200" data-mp="123dpns8z6wv1">
                            18 days
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6201" data-mp="4etslb9afbrd">
                            <TrendingDownIcon size={14} className="mr-1" data-id="element-6202" data-mp="9dn8fac1reup" />
                            -5 days
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6203" data-mp="j6cflt0ke6k8">
                          This quote is closing faster than average
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6204" data-mp="3mtmb4ptvpkmg">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6205" data-mp="14wrm7enudldb">
                          Average Value
                        </div>
                        <div className="flex items-end" data-id="element-6206" data-mp="10whgm33yowyz">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6207" data-mp="1eup9nzxvne4v">
                            {formatCurrency(22500)}
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6208" data-mp="1nucbunyfknyz">
                            <TrendingUpIcon size={14} className="mr-1" data-id="element-6209" data-mp="1jsz428bs2apf" />
                            +32%
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6210" data-mp="1xjm3k2pd44mk">
                          This quote is higher value than average
                        </div>
                      </div>
                    </div>
                    <div className="mt-6 bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6211" data-mp="27g7a4sh15nsi">
                      <div className="flex justify-between items-center mb-4" data-id="element-6212" data-mp="22hdwn01qtwsc">
                        <div className="text-sm font-medium text-gray-700" data-id="element-6213" data-mp="2m5s4uavqwbjn">
                          Quote Value Distribution
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-6214" data-mp="2c7m4vyti1fhf">
                          Last 6 months
                        </div>
                      </div>
                      <div className="h-40 flex items-end justify-between" data-id="element-6215" data-mp="2h8a4v9zph6ns">
                        <div className="flex flex-col items-center" data-id="element-6216" data-mp="22fq7kpz8lte9">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '30%'
                      }} data-id="element-6217" data-mp="2789i1e2mo8eu"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6218" data-mp="1tei9a7wq0sk6">
                            $10k-$20k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6219" data-mp="1jjqbp43525pe">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '50%'
                      }} data-id="element-6220" data-mp="1oi1jl99vi64z"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6221" data-mp="1nktccasiw8lv">
                            $20k-$30k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6222" data-mp="1dp0596xkp7bh">
                          <div className="w-8 bg-blue-600 rounded-t" style={{
                        height: '65%'
                      }} data-id="element-6223" data-mp="1imrt9pv3k9ae"></div>
                          <div className="text-xs text-blue-600 font-medium mt-2" data-id="element-6224" data-mp="26d4chwvslsga">
                            $30k-$40k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6225" data-mp="1wlrlf7htj6bb">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '40%'
                      }} data-id="element-6226" data-mp="21lmb57puxpus"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6227" data-mp="2p9x6jvcsaxbo">
                            $40k-$50k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6228" data-mp="imfyel8rn4oz">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '25%'
                      }} data-id="element-6229" data-mp="do4oybmduw7a"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6230" data-mp="sbpt88uzv1gs">
                            $50k-$60k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6231" data-mp="3vt7zwcz162fm">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '15%'
                      }} data-id="element-6232" data-mp="3vvko37vdt914"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6233" data-mp="8q35vqoyiwvt">
                            $60k+
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Recommended Actions */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6234" data-mp="1g1tui9kpmp4m">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6235" data-mp="cqwj8aewcn8v">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6236" data-mp="hq9d3f46quky">
                      <ZapIcon size={18} className="mr-2 text-gray-500" data-id="element-6237" data-mp="mpcaqehu5yiw" />
                      Recommended Actions
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6238" data-mp="qpcywquqlo35">
                    <div className="space-y-4" data-id="element-6239" data-mp="3q747053094mw">
                      <div className="flex items-start bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-6240" data-mp="3q8fby886sifl">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6241" data-mp="3v3ky985i3z47">
                          <PhoneIcon size={16} className="text-blue-600" data-id="element-6242" data-mp="7sl9dzolqcqn" />
                        </div>
                        <div data-id="element-6243" data-mp="37gcrelsfci02">
                          <h3 className="text-gray-900 font-medium" data-id="element-6244" data-mp="37f1pkrijhkbl">
                            Schedule Follow-up Call
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6245" data-mp="3bfbtzzqoo2oc">
                            It's been 5 days since the last contact. Schedule a
                            follow-up call to discuss any questions.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6246" data-mp="2uwfu4fqzkil0">
                            <PlusIcon size={14} className="mr-1" data-id="element-6247" data-mp="2pxmgmnbp8rku" />
                            Schedule Call
                          </button>
                        </div>
                      </div>
                      <div className="flex items-start bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-6248" data-mp="2g7t5fnfgyeh4">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6249" data-mp="2ba1eowqk8yei">
                          <PercentIcon size={16} className="text-green-600" data-id="element-6250" data-mp="2763ba9u7d1fn" />
                        </div>
                        <div data-id="element-6251" data-mp="1x9qjxim4qzo2">
                          <h3 className="text-gray-900 font-medium" data-id="element-6252" data-mp="1x9grlodm4gf7">
                            Offer Time-Limited Discount
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6253" data-mp="18or3be8nkud">
                            Based on historical data, offering a 5% time-limited
                            discount could increase the close probability by
                            15%.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6254" data-mp="3sj6pyklf7xvz">
                            <PenToolIcon size={14} className="mr-1" data-id="element-6255" data-mp="3enuuuc3cs5ej" />
                            Create Offer
                          </button>
                        </div>
                      </div>
                      <div className="flex items-start bg-amber-50 rounded-lg p-4 border border-amber-200" data-id="element-6256" data-mp="34pnik6k0ebiv">
                        <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6257" data-mp="12vxwv7o0rzbc">
                          <FileTextIcon size={16} className="text-amber-600" data-id="element-6258" data-mp="17vk8xds439ik" />
                        </div>
                        <div data-id="element-6259" data-mp="2sc9wrejgxclc">
                          <h3 className="text-gray-900 font-medium" data-id="element-6260" data-mp="2sdcpls0cpp3w">
                            Send Additional Product Information
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6261" data-mp="3234lqqo3mqah">
                            Customer has shown interest in maintenance plans.
                            Send additional information about service packages.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6262" data-mp="3b5dw9gjdajnv">
                            <MailIcon size={14} className="mr-1" data-id="element-6263" data-mp="3l1qm23bskddc" />
                            Send Information
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
      {/* Right sidebar - Notes or History */}
      {(showNotes || showHistory) && <div className="w-80 bg-white border-l border-gray-200 flex flex-col h-full" data-id="element-6264" data-mp="2bd1t4ym7rzw5">
          {showNotes && <>
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6265" data-mp="2fdlp3yv1wxgp">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-6266" data-mp="2kd6zr6jl2u99">
                  <StickyNoteIcon size={18} className="mr-2 text-gray-500" data-id="element-6267" data-mp="2pc9r5o6n51yr" />
                  Notes
                </h3>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowNotes(false)} data-id="element-6268" data-mp="2ual447s8fsl7">
                  <XIcon size={18} data-id="element-6269" data-mp="2ybwwum6ektxm" />
                </button>
              </div>
              <div className="p-4 flex-1 overflow-auto" data-id="element-6270" data-mp="333ocw2rxnh9i">
                <div className="flex justify-between items-center mb-4" data-id="element-6271" data-mp="336ak21awvur7">
                  <h4 className="font-medium text-gray-900" data-id="element-6272" data-mp="382j7e1z9iu9g">Quote Notes</h4>
                  <div className="text-xs text-gray-500" data-id="element-6273" data-mp="3d36w2h00qz0i">
                    {quote.notes.length} notes
                  </div>
                </div>
                <div className="space-y-4 mb-6" data-id="element-6274" data-mp="3hyuk2t2rlm4f">
                  {quote.notes.map(note => <div key={note.id} className={`p-3 rounded-md ${note.isPrivate ? 'bg-blue-50 border border-blue-100' : 'bg-gray-50 border border-gray-200'}`} data-id="element-6275" data-mp="16fg7a9wuibks">
                      <div className="flex justify-between items-start mb-1" data-id="element-6276" data-mp="wew6179bt72k">
                        <div className="font-medium text-gray-900" data-id="element-6277" data-mp="rgunqojq5bs5">
                          {note.author}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-6278" data-mp="1p31r5v4aky2x">{note.date}</div>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-6279" data-mp="1k5s4uoc792jb">{note.text}</p>
                      {note.isPrivate && <div className="mt-2 text-xs flex items-center text-blue-600" data-id="element-6280" data-mp="1fd8q3o1s01cx">
                          <LockIcon size={12} className="mr-1" data-id="element-6281" data-mp="1aefdryy86gec" />
                          Private note
                        </div>}
                    </div>)}
                </div>
                <div className="border-t border-gray-200 pt-4" data-id="element-6282" data-mp="233maqti16xxh">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-6283" data-mp="2321i59fa1p29">Add a Note</h4>
                  <textarea className="w-full border border-gray-300 rounded-md p-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none" placeholder="Type your note here..." rows={4} value={newNote} onChange={e => setNewNote(e.target.value)} data-id="element-6284" data-mp="1bf9t10ir3ltt"></textarea>
                  <div className="flex justify-between mt-2" data-id="element-6285" data-mp="17cli8nah84u7">
                    <label className="flex items-center text-sm text-gray-700" data-id="element-6286" data-mp="1v5vak8sdt4ge">
                      <input type="checkbox" className="mr-2 border-gray-300 rounded text-blue-600 focus:ring-blue-500" checked={privateNote} onChange={e => setPrivateNote(e.target.checked)} data-id="element-6287" data-mp="1z6f5d5phfvzd" />
                      Private note
                    </label>
                    <button className="bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-1.5 transition-colors" onClick={handleAddNote} data-id="element-6288" data-mp="1q7acaewowuul">
                      Save Note
                    </button>
                  </div>
                </div>
              </div>
            </>}
          {showHistory && <>
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6289" data-mp="287v5s2zog8p">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-6290" data-mp="g77mj7hvz98k">
                  <HistoryIcon size={18} className="mr-2 text-gray-500" data-id="element-6291" data-mp="b8d0zxsjb6kr" />
                  History
                </h3>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowHistory(false)} data-id="element-6292" data-mp="3jnobioaeipgp">
                  <XIcon size={18} data-id="element-6293" data-mp="3fne02w3ub6ug" />
                </button>
              </div>
              <div className="p-4 flex-1 overflow-auto" data-id="element-6294" data-mp="3tej1o3qrq97f">
                <div className="relative" data-id="element-6295" data-mp="3tfapgse4j2n5">
                  <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" data-id="element-6296" data-mp="3omr77i4hrjc0"></div>
                  <div className="space-y-6 pl-12 relative" data-id="element-6297" data-mp="30xf48zzrc7i5">
                    {quote.history.map((event, index) => <div key={index} className="relative" data-id="element-6298" data-mp="2vyvcuk2ea3ie" data-mpi={index}>
                        <div className="absolute -left-12 w-8 h-8 rounded-full bg-blue-100 border-4 border-white flex items-center justify-center" data-id="element-6299" data-mp="2vybytefv7z9n">
                          {event.action.includes('created') && <FileTextIcon size={16} className="text-blue-600" data-id="element-6300" data-mp="1p6bffse21ief" />}
                          {event.action.includes('sent') && <SendIcon size={16} className="text-blue-600" data-id="element-6301" data-mp="1k91izss906h3" />}
                          {event.action.includes('viewed') && <EyeIcon size={16} className="text-blue-600" data-id="element-6302" data-mp="1g5d6qwso8mpi" />}
                          {event.action.includes('updated') && <RefreshCwIcon size={16} className="text-blue-600" data-id="element-6303" data-mp="27yck5bdig2vr" />}
                        </div>
                        <div data-id="element-6304" data-mp="23wilt9qsfayr">
                          <div className="flex justify-between items-start" data-id="element-6305" data-mp="23vpp71ljm1uc">
                            <h4 className="font-medium text-gray-900" data-id="element-6306" data-mp="1yy7dx4k1zaj6">
                              {event.action}
                            </h4>
                            <div className="text-xs text-gray-500" data-id="element-6307" data-mp="six0jzo1ttii">
                              {event.date}
                            </div>
                          </div>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6308" data-mp="2z75obb59r99u">
                            {event.user} • {event.details}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </>}
        </div>}
      {/* Item Details Drawer */}
      {showItemDrawer && selectedItem && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end" data-id="element-6309" data-mp="3hwvhjttdvmzn">
          <div className="bg-white w-full max-w-md h-full overflow-auto" data-id="element-6310" data-mp="3mv6rs5nlbzie">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6311" data-mp="3mxjip8bbtk7l">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-6312" data-mp="3rsfcacw7ofmt">
                Item Details
              </h3>
              <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowItemDrawer(false)} data-id="element-6313" data-mp="3vtsiio37uku9">
                <XIcon size={18} data-id="element-6314" data-mp="21i3wy32hbk0w" />
              </button>
            </div>
            <div className="p-6" data-id="element-6315" data-mp="21k6pouv0nr9b">
              <div className="mb-6" data-id="element-6316" data-mp="34shtsvhupfnd">
                <h2 className="text-xl font-bold text-gray-900 mb-1" data-id="element-6317" data-mp="34tt0p46lf3ip">
                  {selectedItem.name}
                </h2>
                <p className="text-gray-600" data-id="element-6318" data-mp="2zw13pvr3cr7n">{selectedItem.description}</p>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-6319" data-mp="3drlf864hq751">
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6320" data-mp="39r1eytomeneo">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6321" data-mp="3nrvpbhv8ayfz">Quantity</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6322" data-mp="3npsqc8c3luz4">
                    {selectedItem.quantity}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6323" data-mp="1b9d4eyv0lu8">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6324" data-mp="3silvuyfe57c9">Unit Price</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6325" data-mp="3skovma6cieu6">
                    {formatCurrency(selectedItem.unitPrice)}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6326" data-mp="5f7gx2z4qktm">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6327" data-mp="oz6a4wnszvtn">Discount</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6328" data-mp="oxv38nz2a7yb">
                    {selectedItem.discount > 0 ? `${selectedItem.discount}%` : 'None'}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6329" data-mp="g1ci3xx2noca">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6330" data-mp="jz0d10yrlh46">Total</div>
                  <div className="text-xl font-bold text-blue-600" data-id="element-6331" data-mp="68wvgnatybl2">
                    {formatCurrency(selectedItem.total)}
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-md mb-6" data-id="element-6332" data-mp="3sgwtark1w035">
                <div className="text-sm text-gray-500 mb-2" data-id="element-6333" data-mp="3sek2rq088heh">Profit Margin</div>
                <div className="flex items-center justify-between mb-2" data-id="element-6334" data-mp="1ad9wo05f1t8">
                  <span className="text-gray-900" data-id="element-6335" data-mp="3jgro8o2bxds5">32% margin</span>
                  <span className="text-green-600 text-sm" data-id="element-6336" data-mp="3oejqoc0loial">Good</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-6337" data-mp="3ge3whq1btxke">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                width: '65%'
              }} data-id="element-6338" data-mp="3gdbzqbvzttsj"></div>
                </div>
              </div>
              <div className="border-t border-gray-200 pt-6" data-id="element-6339" data-mp="36n90htya3jlr">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6340" data-mp="32mp5ox16gs2s">
                  Specifications
                </h3>
                <div className="space-y-4" data-id="element-6341" data-mp="2xnvytngebzbl">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6342" data-mp="2xlj7wksnueme">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6343" data-mp="2snhotzv8ifax">
                      Product Code
                    </div>
                    <div className="text-gray-900" data-id="element-6344" data-mp="2npq01epvz9ay">{`PROD-${selectedItem.id}${selectedItem.id * 100}`}</div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6345" data-mp="ly32svfeii61">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6346" data-mp="lxjodooymbwr">Category</div>
                    <div className="text-gray-900" data-id="element-6347" data-mp="hxj961u1dwon">Irrigation Equipment</div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6348" data-mp="1zt1netl4i18g">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6349" data-mp="24sxuj1p4a8s8">Warranty</div>
                    <div className="text-gray-900" data-id="element-6350" data-mp="24quvjs5zl5bd">2 years standard</div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6 space-x-3" data-id="element-6351" data-mp="2dm17z9zrilmv">
                <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" onClick={() => setShowItemDrawer(false)} data-id="element-6352" data-mp="2dnc6ovecp374">
                  Close
                </button>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-6353" data-mp="1lw6dz00ym7rv">
                  Edit Item
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}
// Navigation Item Component
function NavItem({
  active,
  icon,
  label,
  onClick,
  badge
}) {
  return <button className={`flex items-center w-full px-3 py-2 rounded-md ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} onClick={onClick} data-id="element-6354" data-mp="369ng8vjxqeg2">
      <span className={`${active ? 'text-blue-600' : 'text-gray-500'} mr-3`} data-id="element-6355" data-mp="169s39mb8py7b">
        {icon}
      </span>
      <span className="text-sm font-medium" data-id="element-6356" data-mp="1g63esa30ak0p">{label}</span>
      {badge !== undefined && <span className={`ml-auto ${active ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'} text-xs rounded-full px-2 py-0.5 min-w-[1.25rem] text-center`} data-id="element-6357" data-mp="1g40pxtdlawxk">
          {badge}
        </span>}
    </button>;
}